import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import {
    ADD_FTL_ENTRY,
    BACK,
    FTL_FORM_TABLE_HEADERS,
    FTL_FORM_TABLE_HEADERS_EXCLUDE_TRANSFER_COLUMNS,
    FTL_PAGES,
    FTL_STEPPER_HEADING_DESCRIPTIONS,
    FTL_STEPPER_HEADINGS,
    NEXT,
    CANCEL,
    REMOVE_FTL_ENTRY,
    STEP_FTL_BOL_INDEX,
    SAVE_DRAFT,
    FTL_STATUSES,
    FULL_TRUCKLOAD,
    SHIPPER,
    COUNTRY_OPTIONS,
    CONSIGNEE,
    APPROVE_FTL,
    UNAPPROVE_FTL,
    MARK_DRAFT_FTL,
    STEP_FTL_DOCUMENTS_INDEX,
    STEP_FTL_ITEMS_INDEX,
    STEP_FTL_ADDRESS_INDEX,
    SHIP,
    DElIVERY,
    TIME_IN,
    TIME_OUT,
    FTL_STEPPER_DOCUMENTS_HELPER_TEXT,
    REQUEST_FOR_APPROVAL,
    VIEW_DOCUMENTS,
    PARTIES_TO_TRANSACTION_OPTIONS,
    SHIPMENT_TERMS_OPTIONS,
    DUTIES_TAXES_PAYABLE_BY_OPTIONS,
    CURRENCY_OF_SALE_OPTIONS,
    MARK_FTL_SHIPPED,
    MARK_FTL_UNSHIPPED,
    MARK_FTL_INCOMPLETE,
    MARK_FTL_COMPLETE,
    VIEW_BOL,
    UPLOAD_BOL_AND_CI,
    ADD_DOCUMENT,
    REMOVE_DOCUMENT,
    FTL_STEPPER_UPLOAD_DOCUMENTS, FTL_CARRIER_MISSING_MESSAGE, FTL_BROKER_MISSING_MESSAGE,
    STEP_FTL_PLAN_INDEX, GENERATE, FTL_EXPORT,
    FTL_POA_MISSING_MESSAGE, REGENERATE_DOCUMENT,
} from "../constants";
import React from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import withShipment from "../../../withShipment";
import InputAdornment from "@material-ui/core/InputAdornment";
import {
    Button, FormControlLabel,
    IconButton, Radio,
    RadioGroup,
    Step,
    StepButton,
    Stepper,
    TextField,
    Tooltip,
    Typography,
    Select,
    MenuItem, FormGroup
} from "@material-ui/core";
import InfoIcon from '@material-ui/icons/Info';
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {listAvailableLocations, listPackages, listProducts} from "../../../redux/actions/settings";
import {availableLocationsSelector, packagesSelector, productsSelector} from "../../../redux/selectors/settings";
import Checkbox from "@material-ui/core/Checkbox";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import {getByteArray, ROLE_ADMIN, SAVE} from "../../global/constants";
import {
    fetchFullTruckloadSettings, fetchProductSuppliers,
    listFullTruckloadBrokers,
    listFullTruckloadCarriers, regenerateFTLDocument,
    saveFullTruckload,
    updateFullTruckload
} from "../../../redux/actions/fullTruckload";
import {Box} from "@mui/material";
import {getStateAndProvinceMapping} from "../../../redux/actions/global";
import {stateAndProvinceMappingSelector} from "../../../redux/selectors/global";
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import CheckIcon from "@material-ui/icons/Check";
import CancelIcon from "@material-ui/icons/Cancel";
import DescriptionIcon from '@mui/icons-material/Description';
import {
    fullTruckloadOperationResponseSelector,
    fullTruckloadSettingsSelector, fullTruckloadUnavailableItemsSelector, productsSupplierSelector
} from "../../../redux/selectors/fullTruckload";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import DragAndDrop from "../../global/Dnd/DragAndDrop";
import {DRAG} from "../../automationrules/constants";
import DehazeIcon from "@material-ui/icons/Dehaze";
import {AssignmentTurnedIn} from "@material-ui/icons";
import ScheduleIcon from "@material-ui/icons/Schedule";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import {Unpublished} from "@mui/icons-material";
import {Layout} from "../../global/Table/TablePageHelpers/LayoutObject";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import SaveIcon from '@mui/icons-material/Save';

//styling
import './FullTruckloadForm.css'
import PublishIcon from "@material-ui/icons/Publish";
import FileUpload from "../../global/FileUpload";
import {fetchFullTruckloadCarriers} from "../../../redux/actions/fullTruckloadCarriers";
import {fetchFullTruckloadBrokers} from "../../../redux/actions/fullTruckloadBrokers";
import {fullTruckloadCarriersSelector} from "../../../redux/selectors/fullTruckloadCarrier";
import {fullTruckloadBrokersSelector} from "../../../redux/selectors/fullTruckloadBroker";
import {ERROR, PASSWORD_SUCCESS_MESSAGE, SUCCESS} from "../../settings/ManageUsers/constants";
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import FormLabel from "@material-ui/core/FormLabel";
import {
    inventorySummaryForFTLSelector
} from "../../../redux/selectors/inventory";
import {
    getInventorySummaryForFTL,
} from "../../../redux/actions/inventory";
import {getOpenPOsForFTL} from "../../../redux/actions/purchaseOrders";
import {openPOsForFTLSelector} from "../../../redux/selectors/purchaseOrders";
import DownloadIcon from "@mui/icons-material/Download";

const defaultProps = {
    bgcolor: 'background.paper',
    borderColor: 'rgba(0, 0, 0, 0.23)',
    m: 1,

    border: 1,
    style: { width: '100%', height: '100%' },
};

const daysOfCoverateBaseOnOptions = [7, 14, 21,28]

class FullTruckloadForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [{
                shortcode: "",
                quantity: 0,
                numOfSkids: "0.00",
                isSample: false
            }],
            fromAddress: {
                selectedLocation: "",
                contactName: "",
                companyName: "",
                phoneNumber: "",
                addressLine1: "",
                addressLine2: "",
                city: "",
                stateOrProvince: "",
                postalCode: "",
                country: "",
                email: "",
                shipAddressId: ""
            },
            toAddress: {
                selectedLocation: "",
                contactName: "",
                companyName: "",
                phoneNumber: "",
                addressLine1: "",
                addressLine2: "",
                city: "",
                stateOrProvince: "",
                postalCode: "",
                country: "",
                email: "",
                shipAddressId: ""
            },
            shipmentNumber: "",
            sealNumber: "",
            poNumber: "",
            deliveryNumber: "",
            truckNumber: "",
            trailerNumber: "",
            shipDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0),
            expectedDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0),
            receivedDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0),
            pickupTimeIn: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0),
            pickupTimeOut: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0),
            receivedTimeIn: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0),
            receivedTimeOut: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0),
            carrierName: "",
            brokerName: "",
            portOfEntry: "",
            packingCost: "",
            packingCostCurrency: "",
            freightCostCurrency: "",
            devanCostCurrency: "",
            insuranceCostCurrency: "",
            otherCostsCurrency: "",
            freightCost: "",
            devanCost: "",
            insuranceCost: "",
            otherCosts: "",
            partiesToTransaction: "",
            shipmentTerms: "",
            dutiesTaxesPayableBy: "",
            dutiesTaxesPayableByExporter: "",
            dutiesTaxesPayableByOther: "",
            currencyOfSale: "",
            emergencyPhoneNum: "",
            papsNumber: "",
            shippingCarrier: null,
            shippingCarrierAddress: null,
            notes: "",
            attachments: [],
            billOfLading: null,
            finalDocument: null,
            status: FTL_STATUSES.DRAFT,
            allowChangeOfStatus: true,
            activeStep: this.props.updating ? 1 : 0,
            settingsAttachments: [],
            displayContentCreator: this.getDisplayContentCreator(),
            newAttachments: [],
            deletedAttachments:[],
            filteredPackages: [],
            filteredProducts:[],
            errorMessage:"",
            feedbackBarOpen:false,
            itemsNotEnabled:[],
            shipmentFor: "",
            transferFrom: "",
            transferTo: "",
            daysToCover: "",
            daysOfCoverateBaseOn: "",
            includeOpenPO: false,
            daysToIncludePO: "",
            updateAttachment: false
        }
        this.state.displayContents = this.getDisplayContents()
    }

    componentDidMount() {
        this.props.listProducts()
        this.props.listPackages()
        this.props.getStateAndProvinceMapping()
        this.props.listAvailableLocations()
        this.props.fetchFullTruckloadCarriers()
        this.props.fetchFullTruckloadBrokers()
        this.props.fetchFullTruckloadSettings()
        if (this.props.updating) {
            const editingFullTruckload = this.props.editingFullTruckload
            this.setState({
                items: editingFullTruckload.items,
                fromAddress: editingFullTruckload.fromAddress,
                toAddress: editingFullTruckload.toAddress,
                shipmentNumber: editingFullTruckload.shipmentNumber,
                sealNumber: editingFullTruckload.sealNumber,
                poNumber: editingFullTruckload.poNumber,
                deliveryNumber: editingFullTruckload.deliveryNumber,
                truckNumber: editingFullTruckload.truckNumber,
                trailerNumber: editingFullTruckload.trailerNumber,
                shipDate: new Date(editingFullTruckload.shipDate),
                expectedDate: new Date(editingFullTruckload.expectedDate),
                receivedDate: editingFullTruckload.receivedDate ? new Date(editingFullTruckload.receivedDate) : null,
                pickupTimeIn: new Date(editingFullTruckload.pickupTimeIn),
                pickupTimeOut: new Date(editingFullTruckload.pickupTimeOut),
                receivedTimeIn: editingFullTruckload.receivedTimeIn ? new Date(editingFullTruckload.receivedTimeIn) : null,
                receivedTimeOut: editingFullTruckload.receivedTimeOut ? new Date(editingFullTruckload.receivedTimeOut) : null,
                carrierName: editingFullTruckload.carrierName,
                brokerName: editingFullTruckload.brokerName,
                portOfEntry: editingFullTruckload.portOfEntry,
                packingCost: editingFullTruckload.packingCost,
                freightCost: editingFullTruckload.freightCost,
                devanCost: editingFullTruckload.devanCost,
                insuranceCost: editingFullTruckload.insuranceCost,
                otherCosts: editingFullTruckload.otherCosts,
                packingCostCurrency: editingFullTruckload.packingCostCurrency,
                freightCostCurrency: editingFullTruckload.freightCostCurrency,
                devanCostCurrency: editingFullTruckload.devanCostCurrency,
                insuranceCostCurrency: editingFullTruckload.insuranceCostCurrency,
                otherCostsCurrency: editingFullTruckload.otherCostsCurrency,
                partiesToTransaction: editingFullTruckload.partiesToTransaction,
                shipmentTerms: editingFullTruckload.shipmentTerms,
                dutiesTaxesPayableBy: editingFullTruckload.dutiesTaxesPayableBy,
                dutiesTaxesPayableByExporter: editingFullTruckload.dutiesTaxesPayableByExporter ? editingFullTruckload.dutiesTaxesPayableByExporter : "",
                dutiesTaxesPayableByOther: editingFullTruckload.dutiesTaxesPayableByOther ? editingFullTruckload.dutiesTaxesPayableByOther : "",
                currencyOfSale: editingFullTruckload.currencyOfSale,
                emergencyPhoneNum: editingFullTruckload.emergencyPhoneNum,
                papsNumber: editingFullTruckload.papsNumber,
                shippingCarrier: editingFullTruckload.shippingCarrier,
                shippingCarrierAddress: editingFullTruckload.shippingCarrierAddress,
                notes: editingFullTruckload.notes,
                attachments: [
                    ...editingFullTruckload.attachments,
                    ...(editingFullTruckload.newAttachments || [])
                ].sort((a, b) => ((a.position ?? Infinity) - (b.position ?? Infinity)) || 0),
                billOfLading: editingFullTruckload.billOfLading,
                finalDocument: editingFullTruckload.finalDocument,
                status: editingFullTruckload.status,
                settingsAttachments: editingFullTruckload.newAttachments?.map((attachment) => {
                    return {file: attachment}
                }),
                transferFrom: editingFullTruckload.fromAddress.shipAddressId,
                transferTo: editingFullTruckload.toAddress.shipAddressId,
                shipmentFor: editingFullTruckload.shipmentFor,
                daysToCover: editingFullTruckload.daysToCover,
                daysOfCoverateBaseOn: editingFullTruckload.daysOfCoverateBaseOn,
                includeOpenPO: editingFullTruckload.includeOpenPO,
                daysToIncludePO: editingFullTruckload.daysToIncludePO,

            },
                () => {
                    let data = {
                        transferFrom: this.state.transferFrom,
                        transferTo: this.state.transferTo,
                        daysOfCoverateBaseOn: this.state.daysOfCoverateBaseOn,
                    };

                    this.props.getInventorySummaryForFTL(data, null)

                    if (this.state.includeOpenPO){
                        let openPOInfo = {
                            transferFrom: this.state.transferFrom,
                            transferTo: this.state.transferTo,
                            daysToIncludePO: this.state.daysToIncludePO
                        }
                        this.props.getOpenPOsForFTL(openPOInfo)
                    }

                })
            this.props.fetchProductSuppliers(editingFullTruckload.items)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.dutiesTaxesPayableBy !== "" && prevState.dutiesTaxesPayableBy !== this.state.dutiesTaxesPayableBy) {
            this.setState({
                dutiesTaxesPayableByExporter: "",
                dutiesTaxesPayableByOther: ""
            })
        }
        if (prevState.shipDate !== this.state.shipDate || prevState.brokerName !== this.state.brokerName || prevState.portOfEntry !== this.state.portOfEntry
            || prevState.dutiesTaxesPayableBy !== this.state.dutiesTaxesPayableBy || prevState.dutiesTaxesPayableByExporter !== this.state.dutiesTaxesPayableByExporter
            || prevState.dutiesTaxesPayableByOther !== this.state.dutiesTaxesPayableByOther || prevState.expectedDate !== this.state.expectedDate
            || prevState.carrierName !== this.state.carrierName || prevState.shipmentTerms !== this.state.shipmentTerms
            || prevState.pickupTimeIn !== this.state.pickupTimeIn || prevState.shipmentNumber !== this.state.shipmentNumber
            || prevState.currencyOfSale !== this.state.currencyOfSale || prevState.pickupTimeOut !== this.state.pickupTimeOut
            || prevState.sealNumber !== this.state.sealNumber || prevState.packingCost !== this.state.packingCost
            || prevState.receivedDate !== this.state.receivedDate || prevState.truckNumber !== this.state.truckNumber
            || prevState.freightCost !== this.state.freightCost || prevState.receivedTimeIn !== this.state.receivedTimeIn
            || prevState.trailerNumber !== this.state.trailerNumber || prevState.devanCost !== this.state.devanCost
            || prevState.receivedTimeOut !== this.state.receivedTimeOut || prevState.poNumber !== this.state.poNumber
            || prevState.insuranceCost !== this.state.insuranceCost || prevState.partiesToTransaction !== this.state.partiesToTransaction
            || prevState.deliveryNumber !== this.state.deliveryNumber || prevState.otherCosts !== this.state.otherCosts
            || prevState.emergencyPhoneNum !== this.state.emergencyPhoneNum || prevState.papsNumber !== this.state.papsNumber
            || this.state.displayContentCreator !== prevState.displayContentCreator || prevState.shippingCarrier !== this.state.shippingCarrier
            || this.state.shippingCarrierAddress !== prevState.shippingCarrierAddress
            || prevState.emergencyPhoneNum !== this.state.emergencyPhoneNum
            || this.state.displayContentCreator !== prevState.displayContentCreator
            || prevState.packingCostCurrency !== this.state.packingCostCurrency
            || prevState.freightCostCurrency !== this.state.freightCostCurrency
            || prevState.devanCostCurrency !== this.state.devanCostCurrency
            || prevState.insuranceCostCurrency !== this.state.insuranceCostCurrency
            || prevState.otherCostsCurrency !== this.state.otherCostsCurrency
        ){
            this.setState({
                displayContents: this.getDisplayContents()
            })
        }

        if (prevState.shipDate !== this.state.shipDate) {
            this.onShipDateChange(this.state.shipDate)
        }

        if (prevState.receivedDate !== this.state.receivedDate) {
            this.onReceivedDateChange(this.state.receivedDate)
        }

        if (prevProps.fullTruckloadBrokers !== this.props.fullTruckloadBrokers || prevProps.fullTruckloadCarriers !== this.props.fullTruckloadCarriers || prevState.dutiesTaxesPayableBy !== this.state.dutiesTaxesPayableBy) {
            this.setState({
                displayContentCreator: this.getDisplayContentCreator()
            })
        }
        if (prevProps.fullTruckloadSettings !== this.props.fullTruckloadSettings) {
            const attachments = this.props.fullTruckloadSettings.attachments;
            const updatedAttachments = this.setAttachmentIds(attachments);
            let attachmentsCopy = [...updatedAttachments, ...this.state.settingsAttachments];

            attachmentsCopy.forEach((attachment) =>{
                const curAttachment = this.state.attachments.find((it)=>attachment.file.displayName == it.displayName)
                if (curAttachment && curAttachment.signature) {
                    attachment.signature = curAttachment.signature
                }
            })

            this.setState({
                settingsAttachments: this.orderSettingsAttachments(attachmentsCopy, this.state.attachments)
            });
        }

        // filter out packages with no location enabled
        if (prevProps.packages !== this.props.packages && this.props.packages !== null) {
            const packages = this.props.packages.filter(curPackage =>curPackage.locations.length > 0)
            this.setState({
                filteredPackages: packages
            })
        }

        // filter out products with no location enabled
        if (prevProps.products !== this.props.products && this.props.products !== null) {
            const products = this.props.products.filter(curProduct => curProduct.locations.length > 0)
            this.setState({
                filteredProducts: products
            })
        }

        if (prevProps.unavailableItems !== this.props.unavailableItems) {
            this.setState({
                itemsNotEnabled: this.props.unavailableItems
            })
            if (this.props.unavailableItems.length > 0) {
                let errorMessage = "FTL update failed, items(s) with shortcode "
                let firstShortcode = true
                this.props.unavailableItems.map((shortcode)=>{
                    errorMessage += firstShortcode ? shortcode : ", " +shortcode
                })
                errorMessage += " is not enabled for current ship from location"
                this.setState({
                    errorMessage:errorMessage,
                    feedbackBarOpen: true
                })
            }
        }

        if (this.props.productsSupplier !== prevProps.productsSupplier) {
            let itemsCopy = this.state.items
            itemsCopy.map(item  => {
                let productsSupplier = this.props.productsSupplier[item.shortcode]
                // if only one supplier is related
                if (productsSupplier && productsSupplier.length == 1) {
                    item.supplier = {
                        supplierName: productsSupplier[0].supplierName,
                        supplierId: productsSupplier[0].supplierId,
                    }
                    return item
                }
                // if more than one supplier is related, need the user to choose
                return item
            })
            this.setState({
                items: itemsCopy
            })

            if(this.state.updateAttachment){
                this.updateAttachment()
            }
        }

        if (prevState.transferFrom !== this.state.transferFrom ||
            prevState.transferTo !== this.state.transferTo ||
            prevState.daysOfCoverateBaseOn !== this.state.daysOfCoverateBaseOn) {
            let data = {
                transferFrom: this.state.transferFrom,
                transferTo: this.state.transferTo,
                daysOfCoverateBaseOn: this.state.daysOfCoverateBaseOn,
            };

            this.props.getInventorySummaryForFTL(data, null)
        }

        if ((prevState.includeOpenPO !== this.state.includeOpenPO || prevState.daysToIncludePO !== this.state.daysToIncludePO) && this.state.includeOpenPO && this.state.daysToIncludePO && this.state.transferFrom && this.state.transferTo) {
            let openPOInfo = {
                transferFrom: this.state.transferFrom,
                transferTo: this.state.transferTo,
                daysToIncludePO: this.state.daysToIncludePO
            }
            this.props.getOpenPOsForFTL(openPOInfo)
        }
    }

    displayUnitAndCoverageAfterTransferFromLocation = (row) => {
        let unitInHandAfterTransfer = null
        let daysOfCoverageAfterTransfer = null
        let fromAddressProductInventory = this.props.inventorySummaryForFTL.fromAddressProductInventory
        let fromAddressBoxInventory = this.props.inventorySummaryForFTL.fromAddressBoxInventory
        let fromAddressPOs = []

        let fromAddressOpenPOs = this.state.includeOpenPO && this.state.daysToIncludePO
            ? this.props.openPOsForFTL?.fromAddressOpenPOs || []
            : [];

        if(fromAddressProductInventory){
            let productFrom = fromAddressProductInventory?.find(p => p.shortcode === row.shortcode)
            if(productFrom != undefined){
                fromAddressOpenPOs.forEach((po) => {
                    po.orderItems.forEach((item) => {
                        if (item.shortcode === row.shortcode) {
                            fromAddressPOs.push(po)
                        }
                    });
                });
                unitInHandAfterTransfer = parseFloat(productFrom.quantity) - parseFloat(row.quantity)
                daysOfCoverageAfterTransfer = !isNaN(unitInHandAfterTransfer) && parseFloat(productFrom.runningRate) ? Math.floor(unitInHandAfterTransfer / parseFloat(productFrom.runningRate)) : 0;
            }
        }
        if(fromAddressBoxInventory){
            let boxtFrom = fromAddressBoxInventory.find(b=> b.shortcode === row.shortcode)
            if(boxtFrom != undefined){
                fromAddressOpenPOs.forEach((po) => {
                    po.orderItems.forEach((item) => {
                        if (item.shortcode === row.shortcode) {
                            fromAddressPOs.push(po)
                        }
                    });
                });
                unitInHandAfterTransfer = parseFloat(boxtFrom.quantity) - parseFloat(row.quantity)
                daysOfCoverageAfterTransfer = !isNaN(unitInHandAfterTransfer) && parseFloat(boxtFrom.runningRate) ? Math.floor(unitInHandAfterTransfer / parseFloat(boxtFrom.runningRate)) : 0;
            }
        }

        const renderTooltipContent = (
            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                <tr>
                    <th>PO Number</th>
                    <th style={{ paddingLeft: '6px', paddingRight: '6px', textAlign: 'center' }}>Quantity</th>
                    <th style={{ textAlign: 'center' }}>Expected Date</th>

                </tr>
                </thead>
                <tbody>
                {fromAddressPOs.map((po, index) => (
                    <tr key={index}>
                        <td>{po.poNumber}</td>
                        <td style={{ paddingLeft: '6px', paddingRight: '6px', textAlign: 'center' }}>
                            {po.orderItems.find(item => item.shortcode === row.shortcode)?.quantity}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            {new Date(po.expectedDate).toISOString().split('T')[0]}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        );

        return (
            <>
                <div style={{ borderRadius: "1px", width: "8%", paddingLeft: "5%", display: 'flex', alignItems: 'center' }}>
                    {!isNaN(unitInHandAfterTransfer) ? unitInHandAfterTransfer : ""}
                    {fromAddressPOs.length > 0 && (
                        <Tooltip style = {{marginLeft: '3px'}} title={renderTooltipContent} arrow placement="top">
                            <IconButton size="small">
                                <InfoIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                </div>
                <div style={{borderRadius: "1px", width:"8%", paddingLeft: "7%"}}>
                    {!isNaN(daysOfCoverageAfterTransfer)
                        ? (daysOfCoverageAfterTransfer >= 0 ? daysOfCoverageAfterTransfer : 0)
                        : 0}
                </div>
            </>
        );
    }

    displayUnitAndCoverageAfterTransferToLocation = (row) => {
        let unitInHandAfterTransfer = null
        let daysOfCoverageAfterTransfer = null
        let toAddressProductInventory = this.props.inventorySummaryForFTL.toAddressProductInventory
        let toAddressBoxInventory = this.props.inventorySummaryForFTL.toAddressBoxInventory
        let toAddressPOs = []


        let toAddressOpenPOs = this.state.includeOpenPO && this.state.daysToIncludePO
            ? this.props.openPOsForFTL?.toAddressOpenPOs || []
            : [];

        if(toAddressProductInventory){
            let productFrom = toAddressProductInventory?.find(p => p.shortcode === row.shortcode)

            if(productFrom != undefined){
                toAddressOpenPOs.forEach((po) => {
                    po.orderItems.forEach((item) => {
                        if (item.shortcode === row.shortcode) {
                            toAddressPOs.push(po)
                        }
                    });
                });
                unitInHandAfterTransfer = parseFloat(productFrom.quantity) + parseFloat(row.quantity)
                daysOfCoverageAfterTransfer = !isNaN(unitInHandAfterTransfer) && parseFloat(productFrom.runningRate) ? Math.floor(unitInHandAfterTransfer / parseFloat(productFrom.runningRate)) : 0;
            }
        }
        if(toAddressBoxInventory){
            let boxtFrom = toAddressBoxInventory.find(b=> b.shortcode === row.shortcode)
            if(boxtFrom != undefined){
                toAddressOpenPOs.forEach((po) => {
                    po.orderItems.forEach((item) => {
                        if (item.shortcode === row.shortcode) {
                            toAddressPOs.push(po)
                        }
                    });
                });
                unitInHandAfterTransfer = parseFloat(boxtFrom.quantity) + parseFloat(row.quantity)
                daysOfCoverageAfterTransfer = !isNaN(unitInHandAfterTransfer) && parseFloat(boxtFrom.runningRate) ? Math.floor(unitInHandAfterTransfer / parseFloat(boxtFrom.runningRate)) : 0;
            }
        }

        const renderTooltipContent = (
            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                <tr>
                    <th>PO Number</th>
                    <th style={{ paddingLeft: '6px', paddingRight: '6px', textAlign: 'center' }}>Quantity</th>
                    <th style={{ textAlign: 'center' }}>Expected Date</th>

                </tr>
                </thead>
                <tbody>
                {toAddressPOs.map((po, index) => (
                    <tr key={index}>
                        <td>{po.poNumber}</td>
                        <td style={{ paddingLeft: '6px', paddingRight: '6px', textAlign: 'center' }}>
                            {po.orderItems.find(item => item.shortcode === row.shortcode)?.quantity}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            {new Date(po.expectedDate).toLocaleDateString()}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        );

        return (
            <>
                <div style={{ borderRadius: "1px", width: "8%", paddingLeft: "9%", display: 'flex', alignItems: 'center' }}>
                    {!isNaN(unitInHandAfterTransfer) ? unitInHandAfterTransfer : ""}
                    {toAddressPOs.length > 0 && (
                        <Tooltip style = {{marginLeft: '3px'}} title={renderTooltipContent} arrow placement="top">
                            <IconButton size="small">
                                <InfoIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                </div>
                <div style={{borderRadius: "1px", width:"8%", paddingLeft: "8%"}}>
                    {!isNaN(daysOfCoverageAfterTransfer)
                        ? (daysOfCoverageAfterTransfer >= 0 ? daysOfCoverageAfterTransfer : 0)
                        : 0}
                </div>
            </>
        );
    }

    calculateUnitInHandAfterTransferFromLocation = (row) => {

        let fromAddressProductInventory = this.props.inventorySummaryForFTL.fromAddressProductInventory
        let fromAddressBoxInventory = this.props.inventorySummaryForFTL.fromAddressBoxInventory

        if(fromAddressProductInventory){
            let productFrom = fromAddressProductInventory.find(p => p.shortcode === row.shortcode)
            if(productFrom != undefined){
                let unitInHandAfterTransfer = parseFloat(productFrom.quantity) - row.quantity
                return unitInHandAfterTransfer
            }
        }
        if(fromAddressBoxInventory){
            let boxtFrom = fromAddressBoxInventory.find(b=> b.shortcode === row.shortcode)
            if(boxtFrom != undefined){
                let unitInHandAfterTransfer = parseFloat(boxtFrom.quantity) - row.quantity
                return unitInHandAfterTransfer
            }
        }

        return null
    }

    calculateUnitInHandAfterTransferToLocation = (row) => {

        let toAddressProductInventory = this.props.inventorySummaryForFTL.toAddressProductInventory
        let toAddressBoxInventory = this.props.inventorySummaryForFTL.toAddressBoxInventory

        if(toAddressProductInventory){
            let productFrom = toAddressProductInventory.find(p => p.shortcode === row.shortcode)
            if(productFrom != undefined){
                let unitInHandAfterTransfer = parseFloat(productFrom.quantity)+ row.quantity
                return unitInHandAfterTransfer
            }
        }
        if(toAddressBoxInventory){
            let boxtFrom = toAddressBoxInventory.find(b=> b.shortcode === row.shortcode)
            if(boxtFrom != undefined){
                let unitInHandAfterTransfer = parseFloat(boxtFrom.quantity) + row.quantity
                return unitInHandAfterTransfer
            }
        }

        return null
    }

    getDisplayContents = () => {
        return this.getDisplayContentCreator()(this.handleFieldChange, this.getFieldValue)
    }

    getDisplayContentCreator = () => {
        return Layout.newLayout(4, [
            Layout.row([
                Layout.rowElement(1, 'shipDate', 'Ship Date', Layout.elementStyle.dateSelect, null, this.state?.status === FTL_STATUSES.COMPLETED, null, false, null, true, true),
                Layout.rowElement(1, 'shippingCarrier', 'Shipping Carrier', Layout.elementStyle.selectDropdown, this.props.fullTruckloadCarriers ? this.props.fullTruckloadCarriers.filter(carrier => carrier.isShippingCarrier)?.map(carrier => carrier.name) : [], this.state?.status === FTL_STATUSES.COMPLETED),
                Layout.rowElement(1, 'dutiesTaxesPayableBy', 'Duties & Taxes Payable By', Layout.elementStyle.selectDropdown, DUTIES_TAXES_PAYABLE_BY_OPTIONS, this.state?.status === FTL_STATUSES.COMPLETED, null, true, null, true, true),
                Layout.rowElement(1, 'receivedDate', 'Received Date', Layout.elementStyle.dateSelect, null, this.state?.status === FTL_STATUSES.COMPLETED, null),
            ]),
            Layout.row([
                Layout.rowElement(1, 'expectedDate', 'Expected Delivery Date', Layout.elementStyle.dateSelect, null, this.state?.status === FTL_STATUSES.COMPLETED, null, false, null, true, true),
                Layout.rowElement(1, 'shippingCarrierAddress', 'Shipping Carrier Address', Layout.elementStyle.textBox, null, this.state?.status === FTL_STATUSES.COMPLETED),
                this.state?.dutiesTaxesPayableBy === DUTIES_TAXES_PAYABLE_BY_OPTIONS[0] ?
                    Layout.rowElement(1, 'dutiesTaxesPayableByExporter', 'Exporter Account Number', Layout.elementStyle.textBox, null, this.state?.status === FTL_STATUSES.COMPLETED, true, this.state.dutiesTaxesPayableByExporter, null, true, true)
                    : this.state?.dutiesTaxesPayableBy === DUTIES_TAXES_PAYABLE_BY_OPTIONS[2] ?
                        Layout.rowElement(1, 'dutiesTaxesPayableByOther', 'Name of Payer', Layout.elementStyle.textBox, null, this.state?.status === FTL_STATUSES.COMPLETED, true, this.state.dutiesTaxesPayableByOther, null, true, true)
                        :
                        Layout.rowElement(1, '', '', Layout.elementStyle.blankSpacer, null, false, null, true, null, true, true),
                Layout.rowElement(1, 'receivedTimeIn', 'Received-Time In', Layout.elementStyle.timeSelect, null, this.state?.status === FTL_STATUSES.COMPLETED, null),
            ]),
            Layout.row([
                Layout.rowElement(1, 'pickupTimeIn', 'Pick Up-Time In', Layout.elementStyle.timeSelect, null, this.state?.status === FTL_STATUSES.COMPLETED, null, true, null, true, true),
                Layout.rowElement(1, "papsNumber", "PAPS Number", Layout.elementStyle.textBox, null, this.state?.status === FTL_STATUSES.COMPLETED),
                Layout.rowElement(1, 'shipmentTerms', 'Shipment Terms', Layout.elementStyle.selectDropdown, SHIPMENT_TERMS_OPTIONS, this.state?.status === FTL_STATUSES.COMPLETED, null, true, null, true, true),
                Layout.rowElement(1, 'receivedTimeOut', 'Received-Time Out', Layout.elementStyle.timeSelect, null, this.state?.status === FTL_STATUSES.COMPLETED, null),
            ]),
            Layout.row([
                Layout.rowElement(1, 'pickupTimeOut', 'Pick Up-Time Out', Layout.elementStyle.timeSelect, null, this.state?.status === FTL_STATUSES.COMPLETED, null, true, null, true, true),
                Layout.rowElement(1, 'sealNumber', 'Seal Number', Layout.elementStyle.textBox, null, this.state?.status === FTL_STATUSES.COMPLETED),
                Layout.rowElement(1, 'currencyOfSale', 'Currency of Sale', Layout.elementStyle.selectDropdown, CURRENCY_OF_SALE_OPTIONS, this.state?.status === FTL_STATUSES.COMPLETED,null, true, null, true, true),
                Layout.rowElement(1, 'packingCost', 'Packing Cost', Layout.elementStyle.textBoxWithCurrency, null, this.state?.status === FTL_STATUSES.COMPLETED,null,null,"packingCostCurrency"),
            ]),
            Layout.row([
                Layout.rowElement(1, 'brokerName', 'Customs Broker', Layout.elementStyle.selectDropdown, this.props.fullTruckloadBrokers ? this.props.fullTruckloadBrokers.map(broker => broker.name) : [], this.state?.status === FTL_STATUSES.COMPLETED, null, null, null, null, true),
                Layout.rowElement(1, 'truckNumber', 'Truck Number', Layout.elementStyle.textBox, null, this.state?.status === FTL_STATUSES.COMPLETED),
                Layout.rowElement(1, 'partiesToTransaction', 'Parties to Transaction', Layout.elementStyle.selectDropdown, PARTIES_TO_TRANSACTION_OPTIONS, this.state?.status === FTL_STATUSES.COMPLETED, null, true, null, true, true),
                Layout.rowElement(1, 'freightCost', 'Freight Cost', Layout.elementStyle.textBoxWithCurrency, null, this.state?.status === FTL_STATUSES.COMPLETED, null, null, "freightCostCurrency"),
            ]),
            Layout.row([
                Layout.rowElement(1, 'carrierName', 'Billing To (Carrier / Broker)', Layout.elementStyle.selectDropdown, this.props.fullTruckloadCarriers ? this.props.fullTruckloadCarriers.filter(carrier => carrier.isBillingCarrierOrBroker)?.map(carrier => carrier.name) : [] , this.state?.status === FTL_STATUSES.COMPLETED, true, null, null, null, true),
                Layout.rowElement(1, 'trailerNumber', 'Trailer Number', Layout.elementStyle.textBox, null, this.state?.status === FTL_STATUSES.COMPLETED),
                Layout.rowElement(1, 'emergencyPhoneNum', 'Emergency Phone Number', Layout.elementStyle.textBox, null, this.state?.status === FTL_STATUSES.COMPLETED, null, true, null, true, true),
                Layout.rowElement(1, 'devanCost', 'Devan Cost', Layout.elementStyle.textBoxWithCurrency, null, this.state?.status === FTL_STATUSES.COMPLETED, null, null, "devanCostCurrency"),
            ]),
            Layout.row([
                Layout.rowElement(1, 'shipmentNumber', 'Shipment Number', Layout.elementStyle.textBox, null, this.state?.status === FTL_STATUSES.COMPLETED, null, true, null, null, true),
                Layout.rowElement(1, 'poNumber', 'PO Number', Layout.elementStyle.textBox, null, this.state?.status === FTL_STATUSES.COMPLETED),
                Layout.rowElement(1, "", "", Layout.elementStyle.blankSpacer, null, false, false, false, null, true, true),
                Layout.rowElement(1, 'insuranceCost', 'Insurance Cost', Layout.elementStyle.textBoxWithCurrency, null, this.state?.status === FTL_STATUSES.COMPLETED, null, null, "insuranceCostCurrency"),
            ]),
            Layout.row([
                Layout.rowElement(1, "portOfEntry", "Port Number", Layout.elementStyle.selectDropdown, this.props.noaPorts?.map(port => port.portOfEntry + " - " + port.city + ", " + port.state ), this.state?.status === FTL_STATUSES.COMPLETED, null, false, null, null, true),
                Layout.rowElement(1, 'deliveryNumber', 'Delivery Number', Layout.elementStyle.textBox, null, this.state?.status === FTL_STATUSES.COMPLETED),
                Layout.rowElement(1, "", "", Layout.elementStyle.blankSpacer, null, false, false, false, null, true, true),
                Layout.rowElement(1, 'otherCosts', 'Other Costs', Layout.elementStyle.textBoxWithCurrency, null, this.state?.status === FTL_STATUSES.COMPLETED, null, null, "otherCostsCurrency"),
            ])
        ])
    }

    handleFieldChange = (nameValueObject) => {
        this.setState({
            [nameValueObject.name]: nameValueObject.value
        })
    }

    getFieldValue = (displayName, fieldName, elementStyle) => {
        if (elementStyle === Layout.elementStyle.dateSelect || elementStyle === Layout.elementStyle.timeSelect) {
            return this.state[fieldName] ?? ""
        }
        return this.state[fieldName] ?? Layout.getDefaultElementValueFromStyle(elementStyle)
    }

    setAttachmentIds = (attachmentsArray) => {
        let newSettingsAttachments = attachmentsArray
        for (let i = 0; i < newSettingsAttachments.length; i++) {
            newSettingsAttachments[i].id = i
        }
        let newNewSettingsAttachments = []
        let settingsAttachmentFiles = []
        for (let i = 0; i < newSettingsAttachments.length; i++) {
            settingsAttachmentFiles.push(newSettingsAttachments[i].file)
        }
        let attachments = this.props.updating ? this.props.editingFullTruckload.attachments : this.state.attachments
        for (let i = 0; i < attachments.length; i++) {
            if (newSettingsAttachments[this.getFileIndex(settingsAttachmentFiles, attachments[i])]) {
                newNewSettingsAttachments.push(newSettingsAttachments[this.getFileIndex(settingsAttachmentFiles, attachments[i])])
            }
        }
        for (let i = 0; i < newSettingsAttachments.length; i++) {
            if (this.getFileIndex(attachments, newSettingsAttachments[i].file) === -1) {
                newNewSettingsAttachments.push(newSettingsAttachments[i])
            }
        }

        return newNewSettingsAttachments
    }

    setStep = (index) => {
        this.setState({
            activeStep: index,
        });
    };

    getStepContent = (stepIndex) => {
        switch (stepIndex) {
            case STEP_FTL_PLAN_INDEX:
                return this.firstStepContent()
            case STEP_FTL_ITEMS_INDEX:
                return this.secondStepContent()
            case STEP_FTL_ADDRESS_INDEX:
                return this.thirdStepContent()
            case STEP_FTL_BOL_INDEX:
                return this.fourthStepContent()
            case STEP_FTL_DOCUMENTS_INDEX:
                return this.fifthStepContent()
        }
    }

    handleBack = () => {
        // if they are on the first step
        if (this.state.activeStep === 0) {
            this.props.setCurrentPage(FTL_PAGES.TABLE)
        }
        else {
            this.setState({
                activeStep: this.state.activeStep - 1,
            });
        }

    };

    handleCancel = () => {
        this.props.setCurrentPage(FTL_PAGES.TABLE)
    }

    isAddressValid = (address, isToAddress) => {
        return address.contactName !== "" && (address.companyName !== "") && address.phoneNumber !== "" && address.addressLine1 !== "" &&
            address.city !== "" && address.stateOrProvince !== "" && address.postalCode !== "" && address.country !== "" && address.email !== ""
}

    isInputValid = (step) => {
        switch (step) {
            case STEP_FTL_PLAN_INDEX:
                return true
            case STEP_FTL_ITEMS_INDEX:
                return true //TODO: This
            case STEP_FTL_ADDRESS_INDEX:
                return this.isAddressValid(this.state.fromAddress, false) && this.isAddressValid(this.state.toAddress, true)
            case STEP_FTL_BOL_INDEX:
                return !isNaN(Number(this.state.freightCost)) && this.state.freightCost !== "" && !isNaN(Number(this.state.devanCost)) &&
                    this.state.devanCost !== "" && this.state.carrierName !== "" && this.state.brokerName !== "" && this.state.shipmentNumber !== "" &&
                    this.state.sealNumber !== "" && this.state.truckNumber !== "" && this.state.trailerNumber  !== "" && this.state.poNumber !== "" &&
                    this.state.deliveryNumber !== "" && !this.InvalidDate(SHIP) && !this.InvalidDate(DElIVERY) && !this.InvalidDate(TIME_IN) &&
                    !this.InvalidDate(TIME_OUT) && this.state.notes !== ""
            case STEP_FTL_DOCUMENTS_INDEX:
                return true //TODO: This
        }
    }

    handlePreview = (isFinalDoc) => {
        this.props.previewFullTruckloadDocument({path: isFinalDoc ? this.state.finalDocument?.path : this.state.billOfLading?.path, id: this.props.editingFullTruckload.id})
        this.props.setPreviewingFinalDoc(isFinalDoc)
        this.props.setCurrentPage(FTL_PAGES.PREVIEW, null, FTL_PAGES.UPDATE)
    }

    changeStatus = (newStatus, operationName) => {
        if (newStatus === "Approved") {
            const missingFields = [];

            if (!this.state.shipmentNumber) missingFields.push("Shipment Number");
            if (!this.state.shippingCarrier) missingFields.push("Shipping Carrier");
            if (!this.state.sealNumber) missingFields.push("Seal Number");
            if (!this.state.trailerNumber) missingFields.push("Trailer Number");

            // International FTL
            if (this.state.fromAddress?.country !== this.state.toAddress?.country) {
                if (!this.state.papsNumber) missingFields.push("PAPS Number");
                if (!this.state.portOfEntry) missingFields.push("Port Number");
                if (!this.state.currencyOfSale) missingFields.push("Currency of Sale");
                if (!this.state.brokerName) missingFields.push("Customs Broker");
            }

            if (missingFields.length > 0) {
                this.setState({
                    errorMessage:`Cannot save FTL: missing fields - ${missingFields.join(', ')}`,
                    feedbackBarOpen: true
                })
                return;
            }
        }
        if (!this.state.allowChangeOfStatus) {
            return;
        }
        let newSettings = {
            attachments: this.state.newAttachments.filter(attachment => attachment.file?.byteArray),
            deletedAttachments: this.state.deletedAttachments,
        }
        let editingFullTruckload = this.props.editingFullTruckload
        editingFullTruckload.status = newStatus
        this.setState({
            allowChangeOfStatus: false,
        })
        editingFullTruckload.attachments = [
            ...(editingFullTruckload.attachments || []),
            ...(editingFullTruckload.newAttachments || [])
        ].sort((a, b) => ((a.position ?? Infinity) - (b.position ?? Infinity)) || 0)
        editingFullTruckload.newAttachments = this.state.newAttachments.filter(attachment => attachment.file?.displayName).map(attachment => {return {file : {displayName: attachment.file?.displayName}}})
        this.props.updateFullTruckload(editingFullTruckload, newSettings,
            ((success) => {
                if(success){
                    this.setState({
                        status: newStatus
                    })
                }
                this.setState({
                    allowChangeOfStatus: true
                })
            }), operationName)
    }

    handleSave = () => {
        if (this.state.status === "Approved") {
            const missingFields = [];

            if (!this.state.shipmentNumber) missingFields.push("Shipment Number");
            if (!this.state.shippingCarrier) missingFields.push("Shipping Carrier");
            if (!this.state.sealNumber) missingFields.push("Seal Number");
            if (!this.state.trailerNumber) missingFields.push("Trailer Number");

            // International FTL
            if (this.state.fromAddress?.country !== this.state.toAddress?.country) {
                if (!this.state.papsNumber) missingFields.push("PAPS Number");
                if (!this.state.portOfEntry) missingFields.push("Port Number");
                if (!this.state.currencyOfSale) missingFields.push("Currency of Sale");
                if (!this.state.brokerName) missingFields.push("Customs Broker");
            }

            if (missingFields.length > 0) {
                this.setState({
                    errorMessage:`Cannot Approve FTL: missing fields - ${missingFields.join(', ')}`,
                    feedbackBarOpen: true
                })
                return;
            }
        }

        this.setState({
            allowChangeOfStatus: false
        })
        let newSettings = {
            attachments: this.state.settingsAttachments.filter(attachment => attachment.file?.byteArray),
            deletedAttachments: this.state.deletedAttachments,
        }
        // filters out all the attachments that is from a different toAddress location
        let tempState = this.state
        let tempAttachments = []
        this.state.attachments.forEach((attachment) => {
            let file = this.state.settingsAttachments.find((curAttachment) => curAttachment.file.displayName === attachment.displayName);
            if (!file){
                return
            }
            tempAttachments.push(attachment)
        });
        tempState.attachments = tempAttachments
        if (this.props.creating) {
            this.props.saveFullTruckload(tempState, newSettings,() => {
                this.props.setCurrentPage(FTL_PAGES.TABLE)
                this.setState({
                    allowChangeOfStatus: true
                })
            })
        }
        else if (this.props.updating) {
            let info = tempState
            info.id = this.props.editingFullTruckload.id
            this.props.updateFullTruckload(tempState, newSettings, (success) => {
                if(success){
                    this.props.setCurrentPage(FTL_PAGES.TABLE)
                }
                this.setState({
                    allowChangeOfStatus: true
                })
            })
        }
    }

    isAutoPlan = () => {
        const isValidString = (value) => value != null && value !== "" && value !== undefined;

        return this.state.shipmentFor === "Warehouse"
            && isValidString(this.state.transferFrom)
            && isValidString(this.state.transferTo)
            && isValidString(this.state.daysToCover)
            && isValidString(this.state.daysOfCoverateBaseOn);
    }

    handleNextAndCalculate = () => {
        if (this.state.activeStep === 0 && this.state.transferFrom && this.state.transferFrom != ""){

            let data = {
                transferFrom: this.state.transferFrom,
                transferTo: this.state.transferTo,
                daysOfCoverateBaseOn: this.state.daysOfCoverateBaseOn,
            }
            if (this.state.includeOpenPO){
                let openPOInfo = {
                    transferFrom: this.state.transferFrom,
                    transferTo: this.state.transferTo,
                    daysToIncludePO: this.state.daysToIncludePO
                }
                this.props.getOpenPOsForFTL(openPOInfo)
                this.props.getInventorySummaryForFTL(data, null, () => {
                    this.autoPlan();
                    this.handleNext();
                });
            }
            else{
                this.props.getInventorySummaryForFTL(data, null, () => {
                    this.autoPlan();
                    this.handleNext();
                });
            }
        }
    }

    autoPlan = () => {
        let itemToTransfer = []

        let fromAddressProductInventory = this.props.inventorySummaryForFTL.fromAddressProductInventory
        let fromAddressBoxInventory = this.props.inventorySummaryForFTL.fromAddressBoxInventory
        let toAddressProductInventory = this.props.inventorySummaryForFTL.toAddressProductInventory
        let toAddressBoxInventory = this.props.inventorySummaryForFTL.toAddressBoxInventory

        toAddressProductInventory.forEach(product => {

            let toAddressDaysOfCoverage = Math.floor(parseFloat(product.quantity) / parseFloat(product.runningRate))
            let uncoverDays = this.state.daysToCover - toAddressDaysOfCoverage
            if (uncoverDays>0){

                let unitToTransfer = Math.ceil(this.state.daysToCover * parseFloat(product.runningRate) - parseFloat(product.quantity))
                if (unitToTransfer%parseFloat(product.boxQuantity) !== 0 ){
                    unitToTransfer = unitToTransfer + (parseFloat(product.boxQuantity) - unitToTransfer%parseFloat(product.boxQuantity))
                }

                let productFrom = fromAddressProductInventory.find(p => p.productId === product.productId)
                if(productFrom != undefined){

                    let unitInHandAfterTransfer = parseFloat(productFrom.quantity) - unitToTransfer
                    let item = {
                        shortcode: product.shortcode,
                        quantity: unitToTransfer,
                        numOfSkids: this.calculateNumOfSkids(product.shortcode, unitToTransfer),
                        isSample: false
                    }

                    let productsSupplier = this.props.productsSupplier[product.shortcode]
                    if (productsSupplier && productsSupplier.length == 1) {
                        item.supplier = {
                            supplierName: productsSupplier[0].supplierName,
                            supplierId: productsSupplier[0].supplierId,
                        }
                    }
                    itemToTransfer.push(item)
                }
            }
        })

        toAddressBoxInventory.forEach(box => {
            let toAddressDaysOfCoverage = Math.floor(parseFloat(box.quantity) / parseFloat(box.runningRate))
            let uncoverDays = this.state.daysToCover - toAddressDaysOfCoverage
            if (uncoverDays>0){

                let unitToTransfer = Math.ceil(this.state.daysToCover * parseFloat(box.runningRate) - parseFloat(box.quantity))
                let boxtFrom = fromAddressBoxInventory.find(b=> b.boxId === box.boxId)
                if(boxtFrom != undefined){

                    let unitInHandAfterTransfer = parseFloat(boxtFrom.quantity) - unitToTransfer
                    let item = {
                        shortcode: box.shortcode,
                        quantity: unitToTransfer,
                        numOfSkids: this.calculateNumOfSkids(box.shortcode, unitToTransfer),
                        isSample: false
                    }

                    let productsSupplier = this.props.productsSupplier[box.shortcode]
                    if (productsSupplier && productsSupplier.length == 1) {
                        item.supplier = {
                            supplierName: productsSupplier[0].supplierName,
                            supplierId: productsSupplier[0].supplierId,
                        }
                    }
                    itemToTransfer.push(item)
                }
            }
        })

        // group by brand (boxes and products without a brand last), then shortcode
        const brandOf = (shortcode) => this.props.products?.find(product => product.shortcode === shortcode)?.brand || ""
        itemToTransfer.sort((a, b) => {
            const brandA = brandOf(a.shortcode)
            const brandB = brandOf(b.shortcode)
            if (!brandA !== !brandB) return brandA ? -1 : 1
            return brandA.localeCompare(brandB) || (a.shortcode || "").localeCompare(b.shortcode || "")
        })

        if(itemToTransfer.length === 0){
            itemToTransfer.push({
                shortcode: "",
                quantity: 0,
                numOfSkids: "0.00",
                isSample: false
            })
        }

        this.setState({
            items: itemToTransfer,
            updateAttachment: true
        })
        this.props.fetchProductSuppliers(itemToTransfer)
    }

    handleNext = () => {
        if (this.state.activeStep === FTL_STEPPER_HEADINGS.length - 1) {
            if (this.state.status === FTL_STATUSES.DRAFT) {
                this.state.status = FTL_STATUSES.REQUEST_APPROVAL
            }
            this.handleSave()
        }

        else {

            this.setState({
                    activeStep: this.state.activeStep + 1,
                }
            );
        }
    }

    InvalidDate = (type) => {
        let today = new Date()
        let date
        switch (type) {
            case SHIP:
                date = this.state.shipDate
                today.setHours(0, 0, 0, 0)
                break
            case DElIVERY:
                date = this.state.expectedDate
                today.setHours(0, 0, 0, 0)
                break
            case TIME_IN:
                date = this.state.pickupTimeIn
                break
            case TIME_OUT:
                date = this.state.pickupTimeOut
                break
        }
        return date < today && this.props.creating
    }

    onShipDateChange = (date) => {
        let newPickupTimeIn = this.state.pickupTimeIn
        let newPickupTimeOut = this.state.pickupTimeOut

        let newShipDateYear = new Date(date).getFullYear()
        let newShipDateMonth = new Date(date).getMonth()
        let newShipDateDate = new Date(date).getDate()

        new Date(newPickupTimeIn).setFullYear(newShipDateYear)
        new Date(newPickupTimeIn).setMonth(newShipDateMonth)
        new Date(newPickupTimeIn).setDate(newShipDateDate)

        new Date(newPickupTimeOut).setFullYear(newShipDateYear)
        new Date(newPickupTimeOut).setMonth(newShipDateMonth)
        new Date(newPickupTimeOut).setDate(newShipDateDate)

        this.setState({
            pickupTimeIn: newPickupTimeIn,
            pickupTimeOut: newPickupTimeOut
        })
    }

    onReceivedDateChange = (date) => {
        if (date) {
            let newReceivedTimeIn = this.state.receivedTimeIn
            let newReceivedTimeOut = this.state.receivedTimeOut

            let newReceivedDateYear = new Date(date).getFullYear()
            let newReceivedDateMonth = new Date(date).getMonth()
            let newReceivedDateDate = new Date(date).getDate()

            newReceivedTimeIn.setFullYear(newReceivedDateYear)
            newReceivedTimeIn.setMonth(newReceivedDateMonth)
            newReceivedTimeIn.setDate(newReceivedDateDate)

            newReceivedTimeOut.setFullYear(newReceivedDateYear)
            newReceivedTimeOut.setMonth(newReceivedDateMonth)
            newReceivedTimeOut.setDate(newReceivedDateDate)

            this.setState({
                receivedTimeIn: newReceivedTimeIn,
                receivedTimeOut: newReceivedTimeOut
            })
        }
    }

    onLocationChange = (address, newLocationName, isToAddress) => {
        if (newLocationName === "" || !newLocationName) {
            let newAddress = address
            newAddress.selectedLocation = ""
            newAddress.contactName = ""
            newAddress.companyName = ""
            newAddress.phoneNumber = ""
            newAddress.addressLine1 = ""
            newAddress.addressLine2 = ""
            newAddress.city = ""
            newAddress.stateOrProvince = ""
            newAddress.postalCode = ""
            newAddress.country = ""
            newAddress.email = ""
            newAddress.shipAddressId = ""

            this.setState({
                fromAddress: isToAddress ? this.state.fromAddress : newAddress,
                toAddress: isToAddress ? newAddress : this.state.toAddress
            })
            return
        }
        let newAddress = address
        let selectedLocation = this.props.availableLocations.find(location => { return location.name === newLocationName })
        newAddress.selectedLocation = newLocationName
        newAddress.contactName = selectedLocation.contactName ? selectedLocation.contactName : ""
        newAddress.companyName = selectedLocation.companyName ? selectedLocation.companyName : ""
        newAddress.phoneNumber = selectedLocation.phone ? selectedLocation.phone : ""
        newAddress.addressLine1 = selectedLocation.addressLine1 ? selectedLocation.addressLine1 : ""
        newAddress.addressLine2 = selectedLocation.addressLine2 ? selectedLocation.addressLine2 : ""
        newAddress.city = selectedLocation.city ? selectedLocation.city : ""
        newAddress.stateOrProvince = selectedLocation.state ? selectedLocation.state : ""
        newAddress.postalCode = selectedLocation.postalCode ? selectedLocation.postalCode : ""
        newAddress.country = selectedLocation.country ? selectedLocation.country : ""
        newAddress.email = selectedLocation.email ? selectedLocation.email : ""
        newAddress.shipAddressId = selectedLocation.shipAddressId ? selectedLocation.shipAddressId : ""
        this.setState({
            fromAddress: isToAddress ? this.state.fromAddress : newAddress,
            toAddress: isToAddress ? newAddress : this.state.toAddress
        })

        let newAttachments = []
        let settingsAttachments = this.props.fullTruckloadSettings?.attachments ? this.props.fullTruckloadSettings?.attachments : []
        let isDomesticShipment = this.state.fromAddress?.country === this.state.toAddress?.country

        this.sortBySequence(settingsAttachments).forEach(({ shortcodes, supplierId, file, shipAddressId, requiredForDomestic, requiredForInternational}) => {
            const match = this.state.items.some(({ shortcode, supplier: itemSupplier }) => {
                const itemSupplierId = itemSupplier?.supplierId
                const shortcodeMatch = (!shortcodes?.length && !supplierId) || shortcodes.includes(shortcode);
                const supplierMatch = supplierId ? supplierId === itemSupplierId : true;
                const shipAddressMatch = shipAddressId && this.state.toAddress?.shipAddressId ? shipAddressId === this.state.toAddress.shipAddressId : true;
                return shortcodeMatch && supplierMatch && shipAddressMatch;
            });

            if (match && (isDomesticShipment ? requiredForDomestic : requiredForInternational)){
                newAttachments.push({
                    ...file,
                    shortcode: shortcodes,
                    ...(supplierId && { supplierId })
                })
            }
        })

        this.setState({
            attachments: newAttachments,
            settingsAttachments: this.orderSettingsAttachments(this.state.settingsAttachments, newAttachments)
        })
    }

    addEntry = () => {
        let newItems = this.state.items
        newItems.push({
            shortcode: "",
            quantity: 0,
            numOfSkids: "0.00",
            isSample: false,
            locations: []
        })

        this.setState({
            items: newItems
        })
    }

    removeItem = (index) => {
        let newItems = this.state.items
        newItems.splice(index, 1)

        let newAttachments = this.state.attachments
        let shortcodes = []
        for (let i = 0; i < newItems.length; i++) {
            if (!shortcodes.includes(newItems[i].shortcode)) {
                shortcodes.push(newItems[i].shortcode)
            }
        }
        let settingsAttachments = this.props.fullTruckloadSettings?.attachments ? this.props.fullTruckloadSettings?.attachments : []
        for (let i = 0; i < settingsAttachments.length; i++) {
            let removeAttachment = !!(settingsAttachments[i].shortcodes?.length || settingsAttachments[i].supplierId)
            for (let j = 0; j < settingsAttachments[i].shortcodes.length; j++) {
                if (shortcodes.includes(settingsAttachments[i].shortcodes[j])) {
                    removeAttachment = false
                }
            }
            if (removeAttachment) {
                let attachmentIndex = this.getFileIndex(newAttachments, settingsAttachments[i].file)
                if (attachmentIndex !== -1) {
                    newAttachments.splice(attachmentIndex, 1)
                }
            }
        }

        this.setState({
            items: newItems,
            attachments: newAttachments,
            settingsAttachments: this.orderSettingsAttachments(this.state.settingsAttachments, newAttachments)
        })
    }

    updateAttachment = () => {
        let newAttachments = []
        let settingsAttachments = this.props.fullTruckloadSettings?.attachments
            ? this.props.fullTruckloadSettings?.attachments
            : []
        let isDomesticShipment = this.state.fromAddress?.country === this.state.toAddress?.country

        this.sortBySequence(settingsAttachments).forEach(({ shortcodes, supplierId, file, shipAddressId, requiredForDomestic, requiredForInternational }) => {
            const match = this.state.items?.some(({ shortcode, supplier: itemSupplier }) => {
                const itemSupplierId = itemSupplier?.supplierId
                const shortcodeMatch = (!shortcodes?.length && !supplierId) || shortcodes.includes(shortcode)
                const supplierMatch = supplierId ? supplierId === itemSupplierId : true
                const shipAddressMatch = shipAddressId && this.state.toAddress?.shipAddressId
                    ? shipAddressId === this.state.toAddress.shipAddressId
                    : true
                return shortcodeMatch && supplierMatch && shipAddressMatch
            })

            if (match && (isDomesticShipment ? requiredForDomestic : requiredForInternational)) {
                newAttachments.push({
                    ...file,
                    shortcode: shortcodes,
                    ...(supplierId && { supplierId })
                })
            }
        })

        this.setState({
            attachments: newAttachments,
            settingsAttachments: this.orderSettingsAttachments(this.state.settingsAttachments, newAttachments),
            updateAttachment: false
        })
    }

    onShortcodeChange = (value, index) => {
        let newItems = this.state.items
        for (let i = 0; i < newItems.length; i++) {
            if (newItems[i].shortcode === value) {
                return
            }
        }
        newItems[index].shortcode = value
        newItems[index].quantity = 0
        newItems[index].numOfSkids = "0.00"

        const productsSupplier = this.props.productsSupplier?.[newItems[index]?.shortcode];
        if (Array.isArray(productsSupplier) && productsSupplier.length === 1) {
            newItems[index].supplier = {
                supplierName: productsSupplier[0].supplierName,
                supplierId: productsSupplier[0].supplierId,
            }

        }
        else{
            newItems[index].supplier = {
                supplierName: "",
                supplierId: "",
            }
        }

        this.setState({
            updateAttachment: true
        })

        this.props.fetchProductSuppliers(newItems)
    }

    onRelatedSupplierChange = (value, index) => {
        let newItems = this.state.items
        newItems[index].supplier = value

        let newAttachments = []
        let settingsAttachments = this.props.fullTruckloadSettings?.attachments ? this.props.fullTruckloadSettings?.attachments : []
        let isDomesticShipment = this.state.fromAddress?.country === this.state.toAddress?.country

        this.sortBySequence(settingsAttachments).forEach(({ shortcodes, supplierId, file, shipAddressId, requiredForDomestic, requiredForInternational}) => {
            const match = newItems.some(({ shortcode, supplier: itemSupplier }) => {
                const itemSupplierId = itemSupplier?.supplierId
                const shortcodeMatch = (!shortcodes?.length && !supplierId) || shortcodes.includes(shortcode);
                const supplierMatch = supplierId ? supplierId === itemSupplierId : true;
                const shipAddressMatch = shipAddressId && this.state.toAddress?.shipAddressId ? shipAddressId === this.state.toAddress.shipAddressId : true;
                return shortcodeMatch && supplierMatch && shipAddressMatch;
            })

            if (match && (isDomesticShipment ? requiredForDomestic : requiredForInternational)){
                newAttachments.push({
                    ...file,
                    shortcode: shortcodes,
                    ...(supplierId && { supplierId }) // Add supplierId only if it exists
                })
            }
        })

        this.setState({
            attachments: newAttachments,
            settingsAttachments: this.orderSettingsAttachments(this.state.settingsAttachments, newAttachments)
        })
    }

    onQuantityChange = (value, index) => {
        let newItems = this.state.items
        if (value >= 0 || value === '') {
            newItems[index].quantity = value === '' ? '' : Number(value)
            newItems[index].numOfSkids = value === '' ? '0.00' : this.calculateNumOfSkids(newItems[index].shortcode, Number(value))

            this.setState({
                items: newItems,
            })
        }
    }

    onNumOfSkidsChange = (value, index) => {
        let newItems = this.state.items
        newItems[index].numOfSkids = value
        let quantity = this.calculateQuantity(newItems[index].shortcode, value)
        newItems[index].quantity = quantity
        if(this.props.inventorySummaryForFTL && Object.keys(this.props.inventorySummaryForFTL).length > 0){
            let calculateUnitAndDaysOfCoverageAfterTransfer = this.calculateUnitAndDaysOfCoverageAfterTransfer(newItems[index].shortcode, Number(quantity))
            newItems[index].unitInHandAfterTransfer = value === '' ? '' : calculateUnitAndDaysOfCoverageAfterTransfer.unitAfterTransfer
            newItems[index].daysOfCoverageAfterTransfer = value === '' ? '' : calculateUnitAndDaysOfCoverageAfterTransfer.daysOfCoverageAfterTransfer
        }

        this.setState({
            items: newItems,
        })
    }

    toggleIsSample = (index) => {
        let newItems = this.state.items
        newItems[index].isSample = !newItems[index].isSample

        this.setState({
            items: newItems,
        })
    }

    calculateQuantity = (shortcode, numOfSkids) => {
        let product = this.state.filteredProducts.find((p) => {
            return p.shortcode === shortcode
        })
        if (!product) {
            product = this.state.filteredPackages.find((p) => {
                return p.shortcode === shortcode
            })
        }
        if (!product) {
            return 0
        }
        return (product.paleteQuantity * Number(numOfSkids)).toFixed(0).toString()
    }

    calculateUnitAndDaysOfCoverageAfterTransfer = (shortcode, quantity) => {
        let product = this.props.inventorySummaryForFTL?.fromAddressProductInventory.find((p) => {
            return p.shortcode === shortcode
        })
        if (!product) {
            product = this.props.inventorySummaryForFTL?.fromAddressBoxInventory.find((p) => {
                return p.shortcode === shortcode
            })
        }
        if (!product) {
            return {unitAfterTransfer: "", daysOfCoverageAfterTransfer: ""}
        }

        let unitAfterTransfer = product.quantity - quantity
        let daysOfCoverageAfterTransfer = Math.floor(unitAfterTransfer / parseFloat(product.runningRate))
        return {unitAfterTransfer: unitAfterTransfer, daysOfCoverageAfterTransfer: daysOfCoverageAfterTransfer}
    }

    calculateNumOfSkids = (shortcode, quantity) => {
        let product = this.state.filteredProducts.find((p) => {
            return p.shortcode === shortcode
        })
        if (!product) {
            product = this.state.filteredPackages.find((p) => {
                return p.shortcode === shortcode
            })
        }
        if (!product) {
            return "0.00"
        }
        let paleteQuantity = product.paleteQuantity
        return Number((quantity / paleteQuantity)) || (quantity / paleteQuantity === 0) ?
            (quantity / paleteQuantity).toFixed(2).toString() :
            (quantity / paleteQuantity).toString()
    }

    onSecondStepExit = () => {
        if (this.props.creating) {
            let newAttachments = []
            let isDomesticShipment = this.state.fromAddress.country === this.state.toAddress.country
            let settingsAttachments = this.props.fullTruckloadSettings?.attachments ? this.props.fullTruckloadSettings?.attachments.map(attachment => attachment.file) : []
            for (let i = 0; i < this.state.attachments.length; i++) {
                let index = this.getFileIndex(settingsAttachments, this.state.attachments[i])
                if (index !== -1) {
                    if (this.props.fullTruckloadSettings?.attachments && this.props.fullTruckloadSettings?.attachments[index].requiredForDomestic && isDomesticShipment) {
                        newAttachments.push(this.state.attachments[i])
                    }
                    if (this.props.fullTruckloadSettings?.attachments && this.props.fullTruckloadSettings?.attachments[index].requiredForInternational && !isDomesticShipment) {
                        newAttachments.push(this.state.attachments[i])
                    }
                }
            }
            this.state.attachments = newAttachments
        }
    }

    getFileIndex = (files, file) => {
        for (let i = 0; i < files?.length; i++) {
            if (files[i]?.displayName === file?.displayName) {
                return i
            }
        }
        return -1
    }

    isAttachmentSelected = (file) => {
        return this.state.attachments.some(
            (attachment) => attachment?.displayName === file?.displayName
        )
    }

    // sequence number from FTL settings; documents without one (including uploads) go last
    getAttachmentSequence = (file) => {
        const sequence = this.props.fullTruckloadSettings?.attachments?.find(
            (attachment) => attachment.file?.displayName === file?.displayName
        )?.sequence
        return sequence === undefined || sequence === null || sequence === "" ? Infinity : Number(sequence)
    }

    sortBySequence = (settingsAttachments) => {
        return [...settingsAttachments].sort((a, b) => (this.getAttachmentSequence(a.file) - this.getAttachmentSequence(b.file)) || 0)
    }

    // selected documents first, in the same order as the attachments that get printed
    orderSettingsAttachments = (settingsAttachments, attachments) => {
        const position = (settingsAttachment) => {
            const index = this.getFileIndex(attachments, settingsAttachment.file)
            return index === -1 ? Infinity : index
        }
        return [...(settingsAttachments || [])].sort((a, b) => (position(a) - position(b)) || 0)
    }

    moveSettingsAttachmentBySelection = (file, shouldBeSelected) => {
        let settingsAttachments = [...this.state.settingsAttachments]
        let index = settingsAttachments.findIndex(
            (attachment) => attachment?.file?.displayName === file?.displayName
        )

        if (index === -1) {
            return settingsAttachments
        }

        const [current] = settingsAttachments.splice(index, 1)

        if (shouldBeSelected) {
            // move to the end of the selected section
            let insertIndex = 0
            while (
                insertIndex < settingsAttachments.length &&
                this.isAttachmentSelected(settingsAttachments[insertIndex].file)
                ) {
                insertIndex++
            }
            settingsAttachments.splice(insertIndex, 0, current)
        } else {
            // move down to the unselected section
            settingsAttachments.push(current)
        }

        return settingsAttachments
    }

    handleDocumentSelectToggle = (file) => {
        let newAttachments = [...this.state.attachments]
        let index = this.getFileIndex(newAttachments, file)
        if (index !== -1) {
            newAttachments.splice(index, 1)
            this.setState({
                attachments: newAttachments,
                settingsAttachments: this.moveSettingsAttachmentBySelection(file, false)
            })
        } else {
            const sequence = this.getAttachmentSequence(file)
            const insertIndex = newAttachments.findIndex((attachment) => this.getAttachmentSequence(attachment) > sequence)
            newAttachments.splice(insertIndex === -1 ? newAttachments.length : insertIndex, 0, file)
            this.setState({
                attachments: newAttachments,
                settingsAttachments: this.orderSettingsAttachments(this.state.settingsAttachments, newAttachments)
            })
        }
    }

    // flag == True if function is being used for attachments from settings
    handleAttachmentsOrderChange = (newSettingsAttachments) => {
        let orderedAttachments = []
        for (let i = 0; i < newSettingsAttachments.length; i++) {
            if (this.getFileIndex(this.state.attachments, newSettingsAttachments[i].file) !== -1) {
                orderedAttachments.push(newSettingsAttachments[i].file)
            }
        }
        this.setState({
            settingsAttachments: newSettingsAttachments,
            attachments: [...orderedAttachments]
        })
    }

    setCurrency = (field, currency) => {
        this.setState({
            [field]: currency
        })
    }

    handleItemsOrderChange = (items) => {
        let newOrderedItems = []
        for (let i = 0; i < items.length; i++) {
            if (this.state.items.indexOf(items[i]) !== -1) {
                newOrderedItems.push(items[i])
            }
        }
        this.setState({
            items: newOrderedItems
        })
    }

    handleChangeShipmentFor = (event) => {
        const { items } = this.state;
        const isItemsEmpty = !items || items.length === 0;
        if (event.target.value == "Customer"){
            this.setState({
                transferTo: "",
                daysToCover: "",
                daysOfCoverateBaseOn: "",
                items: [{
                    shortcode: "",
                    quantity: 0,
                    numOfSkids: "0.00",
                    isSample: false
                }]
            })
        }

        else {
            this.setState({
                shipmentFor: event.target.value,
                items: isItemsEmpty ? [{
                    shortcode: "",
                    quantity: 0,
                    numOfSkids: "0.00",
                    isSample: false
                }] : items
            });
        }
    }

    handleChange = (event) => {
        this.setState(
            {
                [event.target.name]: event.target.value,
            }
        );
    };

    handleCheck = (e) => {
        const checked = e.target.checked
        this.setState({
            includeOpenPO: checked,
            daysToIncludePO:"7"
        })
        if(!checked){
            this.setState({
                daysToIncludePO: ""
            })
        }
    }

    firstStepContent = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <FormLabel style={{fontSize: 12}}>
                </FormLabel>
                <RadioGroup
                    row
                    value={this.state.shipmentFor}
                    onChange={(event) => this.handleChangeShipmentFor(event)}
                >
                    <FormControlLabel
                        style={{marginRight: "20px", width: "300px"}}
                        value="Customer"
                        control={<Radio />}
                        disabled={true}
                        label="Prepare shipment for customer"
                    />
                    <FormControlLabel
                        style={{marginLeft: "20px", marginRight: "20px", width: "300px"}}
                        value="Warehouse"
                        control={<Radio />}
                        disabled={!(this.state.status === FTL_STATUSES.DRAFT || this.state.status === FTL_STATUSES.REQUEST_APPROVAL)}
                        label="Prepare shipment for warehouse"
                    />
                </RadioGroup>
                {this.state.shipmentFor === "Warehouse" ?
                    <div style={{marginTop: 30, marginBottom: 30 }}>
                    <div className="FTLFormSelect">
                        <Autocomplete
                            style={{marginLeft: "20px", marginRight: "20px", width: "205px"}}
                            value={
                                this.props.availableLocations.find(
                                    location => location.shipAddressId === this.state.transferFrom
                                )?.name || ""
                            }
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            options={this.props.availableLocations ? this.props.availableLocations.map(location => location.name) : []}
                            getOptionLabel={(entry) => entry}
                            autoHighlight={true}
                            name="transferFrom"
                            onChange={(event, value) => {
                                if (!value) {
                                    this.setState({ transferFrom: "" });
                                } else {
                                    const selectedLocation = this.props.availableLocations.find(
                                        location => location.name === value
                                    );
                                    if (selectedLocation) {
                                        this.setState({ transferFrom: selectedLocation.shipAddressId });
                                        this.onLocationChange(this.state.fromAddress, value, false);
                                    }
                                }
                            }}
                            disabled={!(this.state.status === FTL_STATUSES.DRAFT || this.state.status === FTL_STATUSES.REQUEST_APPROVAL)}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Transfer from"
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    name="transferFrom"
                                    error={!this.state.transferFrom}
                                    required
                                />
                            }
                        />

                        <Autocomplete
                            style={{marginLeft: "20px", marginRight: "20px", width: "220px"}}
                            value={
                                this.props.availableLocations.find(
                                    location => location.shipAddressId === this.state.transferTo
                                )?.name || ""
                            }
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            options={this.props.availableLocations ? this.props.availableLocations.map(location => location.name) : []}
                            getOptionLabel={(entry) => entry}
                            autoHighlight={true}
                            name="transferTo"
                            onChange={(event, value) => {
                                if (!value) {
                                    this.setState({ transferTo: "" });
                                } else {
                                    const selectedLocation = this.props.availableLocations.find(
                                        location => location.name === value
                                    );
                                    if (selectedLocation) {
                                        this.setState({ transferTo: selectedLocation.shipAddressId });
                                        this.onLocationChange(this.state.toAddress, value, true);
                                    }
                                }
                            }}
                            disabled={!(this.state.status === FTL_STATUSES.DRAFT || this.state.status === FTL_STATUSES.REQUEST_APPROVAL)}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Transfer to"
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    name="transferTo"
                                    error={!this.state.transferTo}
                                    required
                                />
                            }
                        />
                    </div>
                    <div style={{marginTop: 15}} className="FTLFormSelect">
                        <TextField
                            style={{marginLeft: "18px", marginRight: "20px", width: "208px"}}
                            InputLabelProps={{ shrink: true }}
                            value={this.state.daysToCover}
                            required={true}
                            onChange={(event) => {
                                const input = event.target.value;
                                // Allow only numbers
                                if (/^\d*$/.test(input)) {
                                    this.setState({ daysToCover: input });
                                }
                            }}
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                            variant="outlined"
                            disabled={!(this.state.status === FTL_STATUSES.DRAFT || this.state.status === FTL_STATUSES.REQUEST_APPROVAL)}
                            label={"Required days of coverage"}
                        />
                        <Autocomplete
                            style={{marginLeft: "20px", marginRight: "20px", width: "220px"}}
                            value={this.state.daysOfCoverateBaseOn}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            options={daysOfCoverateBaseOnOptions ? daysOfCoverateBaseOnOptions.map(day => day) : []}
                            getOptionLabel={(entry) => `${entry}`}
                            autoHighlight={true}
                            name="daysOfCoverateBaseOn"
                            onChange={(event, newValue) => this.setState({ daysOfCoverateBaseOn: newValue })}
                            disabled={!(this.state.status === FTL_STATUSES.DRAFT || this.state.status === FTL_STATUSES.REQUEST_APPROVAL)}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Average days of coverage"
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    name="daysOfCoverateBaseOn"
                                    required
                                />
                            }
                        />
                    </div>
                    <div className="FTLFormSelect2" style={{marginTop: 15}}>
                        <FormGroup style={{marginTop: 20, marginLeft:20, width: '480px'}}  >
                            <FormControlLabel
                                key={"includeOpenPO"}
                                style={{marginRight: "0px"}}
                                disabled={!(this.state.status === FTL_STATUSES.DRAFT || this.state.status === FTL_STATUSES.REQUEST_APPROVAL)}
                                control={
                                    <Checkbox
                                        checked={this.state.includeOpenPO}
                                        onChange={this.handleCheck}
                                    />
                                }
                                label={
                                    <span>
                                        Include open purchase orders for <u>units in hand</u> and <u>days of coverage</u> calculation
                                    </span>
                                }
                                labelPlacement="end"
                            />
                        </FormGroup>
                    </div>
                    <div className="FTLFormSelect">
                        <div style={{visibility:'hidden', marginLeft: "20px", marginRight: "20px", width: "220px"}}></div>
                        <TextField
                            className={"FTLFormTextField"}
                            InputLabelProps={{ shrink: true }}
                            label="Number of days"
                            value={this.state.daysToIncludePO}
                            required={true}
                            onChange={(event) => {
                                const input = event.target.value;
                                // Allow only numbers
                                if (/^\d*$/.test(input)) {
                                    this.setState({ daysToIncludePO: input });
                                }
                            }}
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                            variant="outlined"
                            disabled={!(this.state.status === FTL_STATUSES.DRAFT || this.state.status === FTL_STATUSES.REQUEST_APPROVAL) || !this.state.includeOpenPO}
                        />
                        </div>

                </div>
                    : this.state.shipmentFor === "Customer" ?
                    <div style={{marginTop: 30, marginBottom: 30 }}>
                    <div className="FTLFormSelect">
                        <Autocomplete
                            style={{marginLeft: "20px", marginRight: "20px", width: "220px"}}
                            value={
                                this.props.availableLocations.find(
                                    location => location.shipAddressId === this.state.transferFrom
                                )?.name || ""
                            }
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            options={this.props.availableLocations ? this.props.availableLocations.map(location => {return location.name}) : []}
                            getOptionLabel={(entry) => entry}
                            autoHighlight={true}
                            name="transferFrom"
                            onChange={(event, value) => {
                                const selectedLocation = this.props.availableLocations.find(
                                    location => location.name === value
                                );
                                if (selectedLocation) {
                                    this.setState({ transferFrom: selectedLocation.shipAddressId });
                                    this.onLocationChange(this.state.fromAddress, value, false)
                                }
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Transfer from"
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    name="transferFrom"
                                    error={!this.state.transferFrom}
                                    required
                                />
                            }
                        />
                    </div>
                </div>
                    :
                    null
                }
            </div>
        )
    }

    secondStepContent = () => {
        const shortcodes = this.state.filteredProducts.map((product) => {
            return product.shortcode
        }).concat(this.state.filteredPackages.map((p) => {
            return p.shortcode
        })).sort()

        const displayAfterTransferColumns =
            this.state.status === FTL_STATUSES.DRAFT ||
            this.state.status === FTL_STATUSES.REQUEST_APPROVAL;

        const afterTransferColumns = [
            'fromLocationUnitInHandAfterTransfer',
            'fromLocationDaysOfCoverageAfterTransfer',
            'toLocationUnitInHandAfterTransfer',
            'toLocationDaysOfCoverageAfterTransfer'
        ];


        const headers = (
            displayAfterTransferColumns
                ? FTL_FORM_TABLE_HEADERS
                : FTL_FORM_TABLE_HEADERS_EXCLUDE_TRANSFER_COLUMNS
        ).map((headCell) => {
            if (afterTransferColumns.includes(headCell.id)) {
                const location =
                    headCell.id === 'fromLocationUnitInHandAfterTransfer' ||
                    headCell.id === 'fromLocationDaysOfCoverageAfterTransfer'
                        ? this.state.fromAddress?.selectedLocation
                        : this.state.toAddress?.selectedLocation;

                return {
                    ...headCell,
                    label: (
                        <>
                            {headCell.label.replace('after transfer', '').trim()} <br />
                            after transfer <br />
                            {location ? `(${location})` : ''}
                        </>
                    )
                };
            }

            return headCell;
        }).filter((headCell) => {
            return displayAfterTransferColumns || !afterTransferColumns.includes(headCell.id);
        });

        let totalBoxes = this.state.items.reduce((sum, item) => {
            let itemsPerBox = this.calculateNumberOfBoxes(item.shortcode);
            let itemTotalBoxes = itemsPerBox && !isNaN(itemsPerBox)
                ? item.quantity / parseFloat(itemsPerBox)
                : 0;

            return sum + itemTotalBoxes;
        }, 0)

        totalBoxes = parseFloat(totalBoxes.toFixed(2))

        let totalWeight = this.state.items.reduce((sum, item) => {
            let itemWeight = this.calculateItemWeight(item.shortcode);
            let itemTotalWegith = itemWeight && !isNaN(itemWeight) && item.quantity
                ? item.quantity * parseFloat(itemWeight)
                : 0;

            return sum + itemTotalWegith;
        }, 0)

        totalWeight = parseFloat(totalWeight).toFixed(2)

        return (
            <Table style={{ tableLayout: "fixed", width: "100%" }}>
                <TableRow className="table">
                    <TableCell className="add-delete-col" />
                    {headers.map((headCell) => (
                        <TableCell key={headCell.id}
                                   style={{textAlign: headCell.textAlign, fontWeight: "bold", width: headCell.width}}>
                            {headCell.label}
                        </TableCell>
                    ))}
                </TableRow>
                {displayAfterTransferColumns?
                    <TableRow className="table">
                        <TableCell style={{ textAlign: "center" }} colSpan={11}>
                            <div style={{
                                justifyContent: "center",
                                marginRight: "auto",
                                marginLeft: "auto",
                            }}>
                                <DragAndDrop
                                    style={{ width: "100%" }}
                                    disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                    cards={this.state.items}
                                    handleTableDisplayChange = {(items) => this.handleItemsOrderChange(items)}
                                    items={this.state.items.map((row, index) => {
                                        return (
                                            {
                                                id: row.id,
                                                component:
                                                    <div style={{
                                                        display: "flex",
                                                        border: this.state.itemsNotEnabled.includes(row.shortcode) ? "1px solid red" : "1px solid grey",
                                                        margin: "5px",
                                                        marginBottom: "20px",
                                                        borderRadius: "10px",
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        height: "75px"
                                                    }}>
                                                        {this.state.status !== FTL_STATUSES.COMPLETED && this.state.status !== FTL_STATUSES.SHIPPED && this.state.status !== FTL_STATUSES.RECEIVED ?
                                                            <>
                                                                <Tooltip title={REMOVE_FTL_ENTRY}>
                                                                    <IconButton onClick={() => this.removeItem(index)}>
                                                                        <RemoveCircleIcon
                                                                            fontSize='small'
                                                                            color='error'
                                                                        />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </>
                                                            :<>
                                                                <Tooltip title={""}>
                                                                    <IconButton>
                                                                        <RemoveCircleIcon
                                                                            fontSize='small'
                                                                            style={{visibility:"hidden"}}
                                                                        />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </>
                                                        }
                                                        <div style={{borderRadius: "1px", width:"15%"}}>
                                                            <Autocomplete
                                                                className="ftl-item-shortcode-field"
                                                                options={shortcodes}
                                                                getOptionLabel={(entry) => entry}
                                                                autoHighlight={true}
                                                                blurOnSelect={false}
                                                                value={row.shortcode}
                                                                onChange={(event, value) => this.onShortcodeChange(value, index)}
                                                                disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                                                renderInput={(params) =>
                                                                    <TextField
                                                                        {...params}
                                                                        variant="outlined"
                                                                        name="shortcode"
                                                                        InputLabelProps={{ shrink: true }}
                                                                    />
                                                                }
                                                            />
                                                        </div>
                                                        <div style={{borderRadius: "1px", width:"15%"}}>
                                                            <Autocomplete
                                                                className="ftl-item-shortcode-field"
                                                                options={this.props.productsSupplier[this.state.items[index].shortcode] || []}
                                                                getOptionLabel={(entry) => entry.supplierName}
                                                                autoHighlight={true}
                                                                blurOnSelect={false}
                                                                value={
                                                                    (this.props.productsSupplier[row.shortcode]?.length
                                                                        ? this.props.productsSupplier[row.shortcode]?.find(
                                                                            (entry) => entry.supplierId === row.supplier?.supplierId
                                                                        )
                                                                        : row.supplier) || null
                                                                }
                                                                onChange={(event, value) => this.onRelatedSupplierChange(value, index)}
                                                                renderInput={(params) =>
                                                                    <TextField
                                                                        {...params}
                                                                        variant="outlined"
                                                                        name="supplier"
                                                                        InputLabelProps={{ shrink: true }}
                                                                    />
                                                                }
                                                            />
                                                        </div>
                                                        <div style={{width:"10%", paddingLeft: "0.5%"}}>
                                                            {
                                                                this.state.filteredProducts.find((p) => {
                                                                    return p.shortcode === row.shortcode
                                                                })?.manufacturerPartNum ??
                                                                this.state.filteredPackages.find((p) => {
                                                                    return p.shortcode === row.shortcode
                                                                })?.manufacturerPartNum
                                                            }
                                                        </div>
                                                        <div style={{borderRadius: "1px", width:"6%", paddingLeft: "0.5%"}}>
                                                            <TextField
                                                                //error={row.quantity < 0}
                                                                type="number"
                                                                variant="outlined"
                                                                name="quantity"
                                                                value={row.quantity}
                                                                onChange={(e) => this.onQuantityChange(e.target.value, index)}
                                                                disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                                                size="small"
                                                            />
                                                        </div>
                                                        <div style={{borderRadius: "1px", width:"6%", paddingLeft: "0.5%"}}>
                                                            <TextField
                                                                variant="outlined"
                                                                name="numOfSkids"
                                                                value={row.numOfSkids}
                                                                onChange={(e) => this.onNumOfSkidsChange(e.target.value, index)}
                                                                disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                                                size="small"
                                                            />
                                                        </div>

                                                        {this.displayUnitAndCoverageAfterTransferFromLocation(row)}
                                                        {this.displayUnitAndCoverageAfterTransferToLocation(row)}

                                                        <div style={{borderRadius: "1px", width:"8%",  paddingLeft: "5%"}}>
                                                            <Checkbox
                                                                checked={row.isSample}
                                                                onChange={() => this.toggleIsSample(index)}
                                                                disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                                                name="sample"
                                                                style={{ color: '#acd685' }}
                                                            />
                                                        </div>
                                                        <Tooltip title={DRAG} style={{float: "right"}}>
                                                            <IconButton
                                                                aria-label='drag'
                                                                disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                                            >
                                                                <DehazeIcon variant='outlined' fontSize='small' />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                            }
                                        )
                                    })}
                                />
                            </div>
                        </TableCell>
                    </TableRow>
                    :
                    <TableRow className="table">
                        <TableCell style={{ textAlign: "center" }} colSpan={7}>
                            <div style={{
                                justifyContent: "center",
                                marginRight: "auto",
                                marginLeft: "auto",
                            }}>
                                <DragAndDrop
                                    disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                    cards={this.state.items}
                                    handleTableDisplayChange = {(items) => this.handleItemsOrderChange(items)}
                                    items={this.state.items.map((row, index) => {
                                        return (
                                            {
                                                id: row.id,
                                                component:
                                                    <div style={{
                                                        display: "flex",
                                                        border: this.state.itemsNotEnabled.includes(row.shortcode) ? "1px solid red" : "1px solid grey",
                                                        margin: "5px",
                                                        marginBottom: "20px",
                                                        borderRadius: "10px",
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        height: "75px"
                                                    }}>
                                                        {this.state.status !== FTL_STATUSES.COMPLETED && this.state.status !== FTL_STATUSES.SHIPPED && this.state.status !== FTL_STATUSES.RECEIVED ?
                                                            <>
                                                                <Tooltip title={REMOVE_FTL_ENTRY}>
                                                                    <IconButton onClick={() => this.removeItem(index)}>
                                                                        <RemoveCircleIcon
                                                                            fontSize='small'
                                                                            color='error'
                                                                        />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </>
                                                            :<>
                                                                <Tooltip title={""}>
                                                                    <IconButton>
                                                                        <RemoveCircleIcon
                                                                            fontSize='small'
                                                                            style={{visibility:"hidden"}}
                                                                        />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </>
                                                        }
                                                        <div style={{borderRadius: "1px", width:"32%", paddingLeft: "1%"}}>
                                                            <Autocomplete
                                                                className="ftl-item-shortcode-field2"
                                                                options={shortcodes}
                                                                getOptionLabel={(entry) => entry}
                                                                autoHighlight={true}
                                                                blurOnSelect={false}
                                                                value={row.shortcode}
                                                                onChange={(event, value) => this.onShortcodeChange(value, index)}
                                                                disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                                                renderInput={(params) =>
                                                                    <TextField
                                                                        {...params}
                                                                        variant="outlined"
                                                                        name="shortcode"
                                                                        InputLabelProps={{ shrink: true }}
                                                                    />
                                                                }
                                                            />
                                                        </div>
                                                        <div style={{borderRadius: "1px", width:"30%", paddingLeft: "1%"}}>
                                                            <Autocomplete
                                                                className="ftl-item-shortcode-field2"
                                                                options={this.props.productsSupplier[this.state.items[index].shortcode] || []}
                                                                getOptionLabel={(entry) => entry.supplierName}
                                                                autoHighlight={true}
                                                                blurOnSelect={false}
                                                                value={
                                                                    (this.props.productsSupplier[row.shortcode]?.length
                                                                        ? this.props.productsSupplier[row.shortcode]?.find(
                                                                            (entry) => entry.supplierId === row.supplier?.supplierId
                                                                        )
                                                                        : row.supplier) || null
                                                                }
                                                                onChange={(event, value) => this.onRelatedSupplierChange(value, index)}
                                                                renderInput={(params) =>
                                                                    <TextField
                                                                        {...params}
                                                                        variant="outlined"
                                                                        name="supplier"
                                                                        InputLabelProps={{ shrink: true }}
                                                                    />
                                                                }
                                                            />
                                                        </div>
                                                        <div style={{width:"25%", paddingLeft: "5%"}}>
                                                            {
                                                                this.state.filteredProducts.find((p) => {
                                                                    return p.shortcode === row.shortcode
                                                                })?.manufacturerPartNum ??
                                                                this.state.filteredPackages.find((p) => {
                                                                    return p.shortcode === row.shortcode
                                                                })?.manufacturerPartNum
                                                            }
                                                        </div>
                                                        <div style={{borderRadius: "1px", width:"20%",  paddingLeft: "6%"}}>
                                                            <TextField
                                                                //error={row.quantity < 0}
                                                                type="number"
                                                                variant="outlined"
                                                                name="quantity"
                                                                value={row.quantity}
                                                                onChange={(e) => this.onQuantityChange(e.target.value, index)}
                                                                disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                                                size="small"
                                                            />
                                                        </div>
                                                        <div style={{borderRadius: "1px", width:"15%", paddingLeft: "5%"}}>
                                                            <TextField
                                                                //error={(isNaN(Number(row.numOfSkids)) || row.numOfSkids === "")}
                                                                variant="outlined"
                                                                name="numOfSkids"
                                                                value={row.numOfSkids}
                                                                onChange={(e) => this.onNumOfSkidsChange(e.target.value, index)}
                                                                disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                                                size="small"
                                                            />
                                                        </div>
                                                        <div style={{borderRadius: "1px", width:"20%"}}>
                                                            <Checkbox
                                                                checked={row.isSample}
                                                                onChange={() => this.toggleIsSample(index)}
                                                                disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                                                name="sample"
                                                                style={{ color: '#acd685' }}
                                                            />
                                                        </div>
                                                        <Tooltip title={DRAG} style={{float: "right"}}>
                                                            <IconButton
                                                                aria-label='drag'
                                                                disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                                            >
                                                                <DehazeIcon variant='outlined' fontSize='small' />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                            }
                                        )
                                    })}
                                />
                            </div>
                        </TableCell>
                    </TableRow>
                }
                <TableRow>
                    {this.state.status !== FTL_STATUSES.COMPLETED && this.state.status !== FTL_STATUSES.SHIPPED && this.state.status !== FTL_STATUSES.RECEIVED?
                        <><TableCell >
                            <>
                                <Tooltip title={ADD_FTL_ENTRY}>
                                    <IconButton onClick={this.addEntry}>
                                        <AddCircleIcon
                                            fontSize="small"
                                            color='secondary'
                                        />

                                    </IconButton>
                                </Tooltip>
                            </>
                        </TableCell>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                        {displayAfterTransferColumns ?
                            <>
                                <TableCell/>
                                <TableCell/>
                                <TableCell/>
                                <TableCell/>
                            </>
                            : null
                        }
                        </>
                        :
                        <TableCell className='add-ftl-item'></TableCell>}
                </TableRow>
                <TableRow>
                    <TableCell/>
                    <TableCell style={{textAlign: "center", fontWeight: "bold", width: "8%"}}>
                        {"Total Skids: " +  this.state.items.reduce((acc, curr) => acc + parseFloat(curr.numOfSkids), 0).toFixed(2).toString()}
                    </TableCell>
                    <TableCell style={{textAlign: "center", fontWeight: "bold", width: "8%"}}>
                        {"Total Cartons: " + totalBoxes}
                    </TableCell>
                    <TableCell style={{textAlign: "center", fontWeight: "bold", width: "8%"}}>
                        {"Total Weight: " + totalWeight}
                    </TableCell>
                    <TableCell/>
                    <TableCell/>
                    <TableCell/>
                    {displayAfterTransferColumns &&
                        <>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                        </>
                    }
                </TableRow>
            </Table>
        )
    }

    thirdStepContent = () => {
        return (
            <div className="ftl-address-section">
                <Box borderRadius="borderRadius" {...defaultProps} style={{borderColor: "lightgray", borderRadius: "5px"}}>
                    <Typography variant="h6" gutterBottom component="div" className="ftl-form-header">
                        {SHIPPER}
                        <hr/>
                    </Typography>

                    <div className="ftl-row-spec">
                        <Autocomplete
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            value={this.state.fromAddress.selectedLocation}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            options={this.props.availableLocations ? this.props.availableLocations.map(location => {return location.name}) : []}
                            getOptionLabel={(entry) => entry}
                            autoHighlight={true}
                            name="fromAddressSelectedLocation"
                            onChange={(event, value) => {this.onLocationChange(this.state.fromAddress, value, false)}}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Location"
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    name="fromAddressSelectedLocation"
                                    error={!this.state.fromAddress.selectedLocation}
                                    required
                                />
                            }
                        />
                    </div>

                    <div className="ftl-row-spec">
                        <TextField
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            //error={this.state.fromAddress.contactName === ""}
                            variant="outlined"
                            name="fromAddressContactName"
                            label="Contact Name"
                            value={this.state.fromAddress.contactName}
                            onChange={(e) => {
                                let newFromAddress = this.state.fromAddress
                                newFromAddress.contactName = e.target.value
                                this.setState({
                                    fromAddress: newFromAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />

                        <TextField
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            //error={this.state.fromAddress.companyName === ""}
                            variant="outlined"
                            name="fromAddressCompanyName"
                            label="Company Name"
                            value={this.state.fromAddress.companyName}
                            onChange={(e) => {
                                let newFromAddress = this.state.fromAddress
                                newFromAddress.companyName = e.target.value
                                this.setState({
                                    fromAddress: newFromAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />

                        <TextField
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            //error={this.state.fromAddress.phoneNumber === ""}
                            variant="outlined"
                            name="fromAddressPhoneNumber"
                            label="Phone Number"
                            value={this.state.fromAddress.phoneNumber}
                            onChange={(e) => {
                                let newFromAddress = this.state.fromAddress
                                newFromAddress.phoneNumber = e.target.value
                                this.setState({
                                    fromAddress: newFromAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />
                    </div>

                    <div className="ftl-row-spec">
                        <TextField
                            style={{margin: '10px', width: '100%'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            //error={this.state.fromAddress.addressLine1 === ""}
                            variant="outlined"
                            name="fromAddressAddressLine1"
                            label="Address Line 1"
                            value={this.state.fromAddress.addressLine1}
                            onChange={(e) => {
                                let newFromAddress = this.state.fromAddress
                                newFromAddress.addressLine1 = e.target.value
                                this.setState({
                                    fromAddress: newFromAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />
                    </div>

                    <div className="ftl-row-spec">
                        <TextField
                            style={{margin: '10px', width: '100%'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            variant="outlined"
                            name="fromAddressAddressLine2"
                            label="Address Line 2"
                            value={this.state.fromAddress.addressLine2}
                            onChange={(e) => {
                                let newFromAddress = this.state.fromAddress
                                newFromAddress.addressLine2 = e.target.value
                                this.setState({
                                    fromAddress: newFromAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />
                    </div>

                    <div className="ftl-row-spec">
                        <TextField
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            //error={this.state.fromAddress.city === ""}
                            variant="outlined"
                            name="fromAddressCity"
                            label="City"
                            value={this.state.fromAddress.city}
                            onChange={(e) => {
                                let newFromAddress = this.state.fromAddress
                                newFromAddress.city = e.target.value
                                this.setState({
                                    fromAddress: newFromAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />

                        <Autocomplete
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            value={this.state.fromAddress.stateOrProvince}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            options={this.props.stateAndProvinceMapping ? this.props.stateAndProvinceMapping.map(state => state.state) : []}
                            getOptionLabel={(entry) => entry}
                            autoHighlight={true}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    {option + " (" + this.props.stateAndProvinceMapping.find(state => state.state === option)?.displayName + ")"}
                                </React.Fragment>
                            )}
                            name="fromAddressStateOrRegion"
                            onChange={(event, value) => {
                                let newFromAddress = this.state.fromAddress
                                newFromAddress.stateOrProvince = value
                                this.setState({
                                    fromAddress: newFromAddress
                                })
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="State or Province"
                                    //error={this.state.fromAddress.stateOrProvince === "" || this.state.fromAddress.stateOrProvince === null || this.state.fromAddress.stateOrProvince === undefined}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    name="fromAddressStateOrRegion"
                                />
                            }
                        />

                        <TextField
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            //error={this.state.fromAddress.postalCode === ""}
                            variant="outlined"
                            name="fromAddressPostalCode"
                            label="Postal Code"
                            value={this.state.fromAddress.postalCode}
                            onChange={(e) => {
                                let newFromAddress = this.state.fromAddress
                                newFromAddress.postalCode = e.target.value
                                this.setState({
                                    fromAddress: newFromAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />
                    </div>

                    <div className="ftl-row-spec">
                        <Autocomplete
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            value={this.state.fromAddress.country}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            options={COUNTRY_OPTIONS}
                            getOptionLabel={(entry) => entry}
                            autoHighlight={true}
                            name="fromAddressCountry"
                            onChange={(event, value) => {
                                let newFromAddress = this.state.fromAddress
                                newFromAddress.country = value
                                this.setState({
                                    fromAddress: newFromAddress
                                })
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Country"
                                    //error={this.state.fromAddress.country === "" || this.state.fromAddress.country === null || this.state.fromAddress.country === undefined}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    name="fromAddressCountry"
                                />
                            }
                        />

                        <TextField
                            style={{margin: '10px', width: '420px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            //error={this.state.fromAddress.email === ""}
                            variant="outlined"
                            name="fromAddressEmail"
                            label="Email"
                            value={this.state.fromAddress.email}
                            onChange={(e) => {
                                let newFromAddress = this.state.fromAddress
                                newFromAddress.email = e.target.value
                                this.setState({
                                    fromAddress: newFromAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />
                    </div>
                </Box>

                <Box borderRadius="borderRadius" {...defaultProps} style={{borderColor: "lightgray", borderRadius: "5px"}}>
                    <Typography variant="h6" gutterBottom component="div" className="ftl-form-header">
                        {CONSIGNEE}
                        <hr/>
                    </Typography>

                    {this.state.shipmentFor != "Customer" &&
                        <div className="ftl-row-spec">
                            <Autocomplete
                                style={{margin: '10px', width: '200px'}}
                                disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                value={this.state.toAddress.selectedLocation}
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                                options={this.props.availableLocations ? this.props.availableLocations.map(location => {return location.name}) : []}
                                getOptionLabel={(entry) => entry}
                                autoHighlight={true}
                                name="toAddressSelectedLocation"
                                onChange={(event, value) => {this.onLocationChange(this.state.toAddress, value, true)}}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label="Location"
                                        InputLabelProps={{ shrink: true }}
                                        variant="outlined"
                                        name="toAddressSelectedLocation"
                                        error={!this.state.toAddress.selectedLocation}
                                        required
                                    />
                                }
                            />
                        </div>
                    }

                    <div className="ftl-row-spec">
                        <TextField
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            //error={this.state.toAddress.contactName === ""}
                            variant="outlined"
                            name="toAddressContactName"
                            label="Contact Name"
                            value={this.state.toAddress.contactName}
                            onChange={(e) => {
                                let newToAddress = this.state.toAddress
                                newToAddress.contactName = e.target.value
                                this.setState({
                                    toAddress: newToAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />

                        <TextField
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            //error={this.state.toAddress.companyName === ""}
                            variant="outlined"
                            name="toAddressCompanyName"
                            label="Company Name"
                            value={this.state.toAddress.companyName}
                            onChange={(e) => {
                                let newToAddress = this.state.toAddress
                                newToAddress.companyName = e.target.value
                                this.setState({
                                    toAddress: newToAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />

                        <TextField
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            //error={this.state.toAddress.phoneNumber === ""}
                            variant="outlined"
                            name="toAddressPhoneNumber"
                            label="Phone Number"
                            value={this.state.toAddress.phoneNumber}
                            onChange={(e) => {
                                let newToAddress = this.state.toAddress
                                newToAddress.phoneNumber = e.target.value
                                this.setState({
                                    toAddress: newToAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />
                    </div>

                    <div className="ftl-row-spec">
                        <TextField
                            style={{margin: '10px', width: '100%'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            //error={this.state.toAddress.addressLine1 === ""}
                            variant="outlined"
                            name="toAddressAddressLine1"
                            label="Address Line 1"
                            value={this.state.toAddress.addressLine1}
                            onChange={(e) => {
                                let newToAddress = this.state.toAddress
                                newToAddress.addressLine1 = e.target.value
                                this.setState({
                                    toAddress: newToAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />
                    </div>

                    <div className="ftl-row-spec">
                        <TextField
                            style={{margin: '10px', width: '100%'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            variant="outlined"
                            name="toAddressAddressLine2"
                            label="Address Line 2"
                            value={this.state.toAddress.addressLine2}
                            onChange={(e) => {
                                let newToAddress = this.state.toAddress
                                newToAddress.addressLine2 = e.target.value
                                this.setState({
                                    toAddress: newToAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />
                    </div>

                    <div className="ftl-row-spec">
                        <TextField
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            //error={this.state.toAddress.city === ""}
                            variant="outlined"
                            name="toAddressCity"
                            label="City"
                            value={this.state.toAddress.city}
                            onChange={(e) => {
                                let newToAddress = this.state.toAddress
                                newToAddress.city = e.target.value
                                this.setState({
                                    toAddress: newToAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />

                        <Autocomplete
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            value={this.state.toAddress.stateOrProvince}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            options={this.props.stateAndProvinceMapping ? this.props.stateAndProvinceMapping.map(state => state.state) : []}
                            getOptionLabel={(entry) => entry}
                            autoHighlight={true}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    {option + " (" + this.props.stateAndProvinceMapping.find(state => state.state === option)?.displayName + ")"}
                                </React.Fragment>
                            )}
                            name="toAddressStateOrRegion"
                            onChange={(event, value) => {
                                let newToAddress = this.state.toAddress
                                newToAddress.stateOrProvince = value
                                this.setState({
                                    toAddress: newToAddress
                                })
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="State or Province"
                                    //error={this.state.toAddress.stateOrProvince === "" || this.state.toAddress.stateOrProvince === null || this.state.toAddress.stateOrProvince === undefined}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    name="toAddressStateOrRegion"
                                />
                            }
                        />

                        <TextField
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            //error={this.state.toAddress.postalCode === ""}
                            variant="outlined"
                            name="toAddressPostalCode"
                            label="Postal Code"
                            value={this.state.toAddress.postalCode}
                            onChange={(e) => {
                                let newToAddress = this.state.toAddress
                                newToAddress.postalCode = e.target.value
                                this.setState({
                                    toAddress: newToAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />
                    </div>

                    <div className="ftl-row-spec">
                        <Autocomplete
                            style={{margin: '10px', width: '200px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            value={this.state.toAddress.country}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            options={COUNTRY_OPTIONS}
                            getOptionLabel={(entry) => entry}
                            autoHighlight={true}
                            name="toAddressCountry"
                            onChange={(event, value) => {
                                let newToAddress = this.state.toAddress
                                newToAddress.country = value
                                this.setState({
                                    toAddress: newToAddress
                                })
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Country"
                                    //error={this.state.toAddress.country === "" || this.state.toAddress.country === null || this.state.toAddress.country === undefined}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    name="toAddressCountry"
                                />
                            }
                        />

                        <TextField
                            style={{margin: '10px', width: '420px'}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            //error={this.state.toAddress.email === ""}
                            variant="outlined"
                            name="toAddressEmail"
                            label="Email"
                            value={this.state.toAddress.email}
                            onChange={(e) => {
                                let newToAddress = this.state.toAddress
                                newToAddress.email = e.target.value
                                this.setState({
                                    toAddress: newToAddress
                                })
                            }}
                            size="medium"
                            InputLabelProps={{shrink: true}}
                        />
                    </div>
                </Box>
            </div>
        )
    }

    fourthStepContent = () => {
        this.onSecondStepExit()
        return (
            <div className='ftl-bol-page'>
                {this.state.displayContents.errorMessage === "" ?
                    this.state.displayContents.content :
                    this.state.displayContents.errorMessage
                }
            </div>
        )
    }

    addAttachment = () => {
        let settingsAttachments = this.state.settingsAttachments
        settingsAttachments.push({file:{newAttachment: true}})
        this.setState({
            settingsAttachments: settingsAttachments
        })
    }

    deleteAttachment = (index) => {
        let deletedAttachments = this.state.deletedAttachments
        let settingsAttachments = this.state.settingsAttachments
        let attachments = this.state.attachments.filter((attachment) => {return attachment.displayName !== settingsAttachments[index].file.displayName})
        if (!settingsAttachments[index].file?.byteArray) deletedAttachments.push(settingsAttachments[index])
        settingsAttachments.splice(index, 1)
        this.setState({
            deletedAttachments: deletedAttachments,
            settingsAttachments: settingsAttachments,
            attachments: attachments
        })
    }

    handleFileAdd = (file, index) => {
        let deletedAttachments = this.state.deletedAttachments;
        let settingsAttachments = [...this.state.settingsAttachments];
        let attachments = [...this.state.attachments];
        let newAttachment = this.getFormattedNewAttachmentObject(file);
        if (settingsAttachments[index].file?.displayName) {
            if (!settingsAttachments[index].file?.byteArray) {
                deletedAttachments.push(settingsAttachments[index]);
            }
            // Find the index in the attachments array
            let attachmentIndex = attachments.findIndex(
                (attachment) => attachment.displayName === settingsAttachments[index].file.displayName
            );
            // If the index is found, replace the attachment with the newAttachment
            if (attachmentIndex !== -1) {
                attachments[attachmentIndex] = newAttachment;
            } else {
                // If the index is not found, add the new attachment to the end of the attachments array
                attachments.push(newAttachment);
            }
        } else {
            // If there was no file at the index, add the new attachment to the end of the attachments array
            attachments.push(newAttachment);
        }
        settingsAttachments[index].file = newAttachment;
        this.setState({
            deletedAttachments,
            attachments,
            settingsAttachments: this.moveSettingsAttachmentBySelection(newAttachment, true),
        });
    };

    handleFileDelete = (file, fileIndex, index) => {
        let settingsAttachments = this.state.settingsAttachments
        let attachments = this.state.attachments.filter((attachment) => {return attachment.displayName !== settingsAttachments[index].file.displayName})
        settingsAttachments[index].file = {newAttachment: true}
        this.setState({
            settingsAttachments: settingsAttachments,
            attachments: attachments
        })
    }

    getFormattedNewAttachmentObject = (file) => {
        return {
            localURL: URL.createObjectURL(file),
            displayName: file.name,
            byteArray: getByteArray(file),
            type: file.type,
            newAttachment: true
        }
    }

    fifthStepContent = () => {
        return (
            <div style={{marginLeft: "25px"}}>
                <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                    <div style={{marginBottom: "15px", marginLeft: "5%"}}>
                        {FTL_STEPPER_DOCUMENTS_HELPER_TEXT}
                    </div>
                    <div style={{justifyContent: "center", border: "1px solid grey", width: "60%", borderRadius: "10px", marginRight: "auto", marginLeft: "auto"}}>
                        <DragAndDrop
                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                            cards={this.state.settingsAttachments}
                            handleTableDisplayChange={(newSettingsAttachments) => this.handleAttachmentsOrderChange(newSettingsAttachments)}
                            items={this.state.settingsAttachments?.map((attachment, index) => {
                                    return (
                                    {
                                        id: attachment.id,
                                        component:
                                            <div style={{
                                                display: "flex",
                                                border: "1px solid grey",
                                                margin: "10px",
                                                width: '98%',
                                                borderRadius: "10px",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                height: "50px"
                                            }}>
                                                {attachment?.file.newAttachment ?
                                                    <>
                                                        <Tooltip title={REMOVE_DOCUMENT}>
                                                            <IconButton onClick={() => this.deleteAttachment(index)}>
                                                                <RemoveCircleIcon
                                                                    fontSize='small'
                                                                    color='error'
                                                                />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <div style={{borderRadius: "1px", width:"90%", height: "65px"}}>
                                                            <FileUpload
                                                                handleFileAdd={(file) => this.handleFileAdd(file, index)}
                                                                handleFileDelete={(file, fileIndex) => this.handleFileDelete(file, fileIndex, index)}
                                                                files={attachment.file?.displayName ? [attachment.file] : []}
                                                                singleFileUpload={true}
                                                                isFTLUpload={true}
                                                            />
                                                        </div>
                                                    </> :
                                                    <>
                                                        <Checkbox
                                                            checked={this.getFileIndex(this.state.attachments, attachment.file) !== -1}
                                                            disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                                            onChange={() => this.handleDocumentSelectToggle(attachment.file)}
                                                            name="document"
                                                            style={{color: '#acd685'}}
                                                        />
                                                        <div style={{width:"90%", height: "28px"}}>
                                                            {attachment.file.displayName}
                                                        </div>
                                                    </>
                                                }

                                                <Tooltip title={DRAG} style={{float: "right"}}>
                                                    <IconButton
                                                        aria-label='drag'
                                                        disabled={this.state.status === FTL_STATUSES.COMPLETED}
                                                    >
                                                        <DehazeIcon variant='outlined' fontSize='small' />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                    }
                                )
                            })}
                        />
                        <div style={{display: "flex"}}>
                            <Tooltip title={ADD_DOCUMENT}>
                                <IconButton onClick={this.addAttachment} style={{marginLeft: "10px"}}>
                                    <AddCircleIcon
                                        fontSize="small"
                                        color='secondary'
                                    />
                                </IconButton>
                            </Tooltip>
                            <div style={{marginTop: "1%"}}>
                                {FTL_STEPPER_UPLOAD_DOCUMENTS}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    closeTag = () => {
        this.setState({
            feedbackBarOpen: !this.state.feedbackBarOpen
        })
    }

    calculateNumberOfBoxes = (shortcode) => {
        let product = this.state.filteredProducts.find((p) => p.shortcode === shortcode);
        if (product) {
            return product.boxQuantity
        }

        product = this.state.filteredPackages.find((p) => p.shortcode === shortcode);
        if (product) {
            return "1"
        }

        return ""
    };

    calculateItemWeight = (shortcode) => {
        let product = this.state.filteredProducts.find((p) => p.shortcode === shortcode);
        if (product) {
            return product.weight
        }

        product = this.state.filteredPackages.find((p) => p.shortcode === shortcode);
        if (product) {
            return product.weight
        }

        return ""
    };

    handleRegenerateDocument = () => {
        this.props.regenerateFTLDocument(this.props.editingFullTruckload.id, () => {
            this.props.setCurrentPage(FTL_PAGES.TABLE)
        })
    }

    handleDownload = () => {
        const { items } = this.state;
        let fromLocationName = (this.state.fromAddress?.selectedLocation || "").replace(" DC", "")
        let toLocationName = (this.state.toAddress?.selectedLocation || "").replace(" DC", "");

        let fileName = 'FTL_' + `${fromLocationName}_${toLocationName}_` + new Date(this.state.shipDate).toISOString().split('T')[0] + '.csv'

        let headers = ['Product', 'Quantity', 'Boxes / Skid', 'Items / Box', 'Skids', 'Total Boxes', 'Weight'];

        let totalSkids = 0
        let totalCartons = 0
        let totalWeight = 0

        let rows = items.map(item => {
            let itemsPerBox = this.calculateNumberOfBoxes(item.shortcode);
            let itemTotalBoxes = itemsPerBox && !isNaN(itemsPerBox) && item.quantity ? ((item.quantity / parseFloat(itemsPerBox))).toFixed(0) : 0
            let boxPerSkid = itemsPerBox && (item.numOfSkids != 0) && !isNaN(itemsPerBox) && item.quantity? (item.quantity/item.numOfSkids/parseFloat(itemsPerBox)).toFixed(2) : 0
            let itemWeight = this.calculateItemWeight(item.shortcode)
            let itemTotalWeight = itemWeight && item.quantity ? (itemWeight * item.quantity).toFixed(2) : 0

            totalSkids += parseFloat(item.numOfSkids) || 0
            totalCartons += parseFloat(itemTotalBoxes) || 0
            totalWeight += parseFloat(itemTotalWeight) || 0

            return [
                item.shortcode,           // Product
                item.quantity,            // Quantity
                boxPerSkid,               // Boxes / Skid
                itemsPerBox,              // Items / Box
                item.numOfSkids,          // Skids
                itemTotalBoxes,           // Total Boxes
                itemTotalWeight,          // Total Weight
            ];
        });

        rows.push([])
        rows.push([`Total Skid: ${totalSkids.toFixed(2)}`, "", `Total Cartons: ${parseFloat(totalCartons).toFixed(2)}`, "",`Total Weight: ${parseFloat(totalWeight).toFixed(2)}`])

        let csvContent = [
            headers.join(','),  // Header row
            ...rows.map(row => row.join(','))  // Data rows
        ].join('\n');

        let blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

        let link = document.createElement('a');
        let url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.display = 'none';
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    allowDownload = () => {
        return this.state.items.length === 0 ||
            (this.state.items.length === 1 &&
                this.state.items[0].shortcode === "" &&
                this.state.items[0].quantity === 0 &&
                this.state.items[0].numOfSkids === "0.00")
    }

    userIsAnAdmin = () => {
        return this.props.user?.authority === ROLE_ADMIN
    }

    regenerateIcon = () =>{
        return (
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-10 -10 1024 1024" width="24" height="24">
            <path stroke="#575757" stroke-width="50" d="M0 0 C1.54714391 -0.00417471 3.09428477 -0.00965299 4.64141995 -0.01631981 C8.88581092 -0.03077508 13.13000772 -0.02652946 17.37440932 -0.019153 C21.95459608 -0.01442385 26.53474068 -0.02692891 31.11491394 -0.03717041 C40.08497911 -0.05436851 49.05497427 -0.05519635 58.02505165 -0.04995751 C65.31553709 -0.04591658 72.60600183 -0.04735844 79.89648628 -0.05270576 C80.93398853 -0.05345419 81.97149079 -0.05420261 83.0404325 -0.05497371 C85.14809092 -0.05650518 87.25574933 -0.05804353 89.36340774 -0.05958868 C109.1294789 -0.07331729 128.89551049 -0.06787341 148.66158075 -0.05640347 C166.74587832 -0.04646995 184.8300736 -0.05941319 202.91435539 -0.08333766 C221.48299005 -0.10771786 240.05157705 -0.11733923 258.6202274 -0.11068493 C269.04526403 -0.10719041 279.47022197 -0.10944019 289.89524651 -0.12693596 C298.76949468 -0.1416444 307.64360876 -0.14231111 316.51785427 -0.12486505 C321.04544876 -0.11634163 325.57280355 -0.11423822 330.10038567 -0.1295166 C334.24624635 -0.14333368 338.39166128 -0.13863914 342.53749598 -0.11927737 C344.03607195 -0.11550788 345.53468338 -0.11846666 347.03322785 -0.12888902 C359.96117338 -0.21239865 365.60869853 1.66266297 374.8047007 10.69563095 C376.3948025 12.28590084 377.97661876 13.8841489 379.55838013 15.48271179 C380.71851455 16.64038388 381.87952586 17.79717777 383.04133362 18.95317054 C386.22261923 22.1235943 389.39133186 25.30632768 392.55809295 28.49125028 C395.97897176 31.92736619 399.41140731 35.35190387 402.84242249 38.77789307 C409.55895118 45.48819861 416.26482593 52.20905499 422.96724958 58.93344578 C430.77516891 66.76606894 438.59397998 74.58778156 446.41336035 82.40896031 C460.36719418 96.36667033 474.31171086 110.33365111 488.25074768 124.30613708 C501.77148588 137.85929408 515.29779223 151.40685846 528.83082581 164.94773865 C530.08075503 166.1983961 530.08075503 166.1983961 531.35593534 167.47431937 C534.70557318 170.82588601 538.05521936 174.17744431 541.40488401 177.52898414 C554.30736113 190.43899987 567.2057923 203.35305753 580.10337051 216.26796724 C583.99776517 220.16759349 587.89230898 224.06707052 591.78722119 227.96617985 C599.97758242 236.16547281 608.16649557 244.36620214 616.35090847 252.57143316 C619.73484984 255.9639511 623.11952671 259.35572554 626.50633812 262.74537849 C629.6092412 265.8509612 632.70981013 268.95885494 635.80855536 272.0685862 C636.92736447 273.19058388 638.04699355 274.31176468 639.16754336 275.43202391 C644.44193623 280.70598014 649.66253919 285.98583798 654.48946166 291.67884946 C657.35107558 294.96926285 660.48690967 297.99482692 663.59156799 301.05369568 C664.3176828 301.77353134 665.04379761 302.493367 665.79191589 303.23501587 C667.35461594 304.783961 668.91839022 306.33182299 670.48314476 307.87869263 C672.96247781 310.33118017 675.43723437 312.78819803 677.91061401 315.24668884 C684.9382277 322.23174738 691.96850887 329.21404635 699.01490784 336.18016052 C703.33694688 340.45361057 707.64910161 344.73682096 711.95501137 349.02651978 C713.59197727 350.65361122 715.23258664 352.27704587 716.87694359 353.89666748 C719.17659045 356.16246451 721.46342129 358.44050703 723.74781799 360.72166443 C724.42374496 361.38163925 725.09967194 362.04161407 725.79608154 362.72158813 C726.42252563 363.35208572 727.04896973 363.98258331 727.69439697 364.63218689 C728.23469386 365.16749779 728.77499075 365.70280869 729.33166027 366.25434113 C734.50152556 372.96326521 735.55816009 378.83820179 735.47896576 387.18865967 C735.48477952 388.25916907 735.49059329 389.32967848 735.49658322 390.43262756 C735.51120233 394.02635343 735.49728825 397.6193984 735.48353577 401.21311951 C735.48814389 403.81295019 735.49449621 406.41277828 735.50244474 409.0126009 C735.51688419 414.66850497 735.51645784 420.3242563 735.5062561 425.98016739 C735.49112704 434.39066975 735.49886062 442.80104323 735.51108933 451.21154472 C735.53215653 466.23258172 735.53032506 481.25355068 735.51877368 496.27459416 C735.50871447 509.41968811 735.50608325 522.56475712 735.51086426 535.70985413 C735.51132257 537.01738546 735.51132257 537.01738546 735.51179014 538.35133157 C735.51303548 541.88972794 735.51430907 545.42812431 735.51562919 548.96652066 C735.52786729 582.16454527 735.51676803 615.36252653 735.4952416 648.56054445 C735.47625895 678.05991235 735.47795745 707.55921119 735.49708557 737.05857849 C735.51850057 770.19558745 735.5269994 803.3325581 735.51463652 836.46957302 C735.51335363 840.00155067 735.51210227 843.53352832 735.51086426 847.06550598 C735.51054795 847.9351794 735.51023164 848.80485281 735.50990574 849.70087997 C735.50535439 862.83824058 735.51067967 875.97557352 735.52078247 889.1129303 C735.53221161 904.04956407 735.52937707 918.98611913 735.50765949 933.92274308 C735.49590372 942.28395878 735.49516282 950.64500405 735.51024419 959.00621537 C735.52025577 965.24424341 735.50941758 971.48206984 735.4903459 977.7200731 C735.48586602 980.24754772 735.48817694 982.77504506 735.49784905 985.30250514 C735.50996564 988.73089824 735.49758454 992.15835657 735.47896576 995.58670044 C735.48833042 996.57413518 735.49769509 997.56156992 735.50734353 998.57892692 C735.42677745 1005.97239415 733.73341985 1011.27958389 728.79200745 1016.84861755 C728.04821838 1017.48025818 727.30442932 1018.1118988 726.5381012 1018.76268005 C725.79689026 1019.40978943 725.05567932 1020.0568988 724.29200745 1020.72361755 C720.21448515 1023.65283256 716.65970222 1024.63748616 711.67020863 1024.64067972 C710.61176058 1024.6461992 709.55331252 1024.65171869 708.46279028 1024.65740544 C707.30383127 1024.6532948 706.14487225 1024.64918416 704.95079327 1024.64494896 C703.71153128 1024.64845503 702.47226929 1024.65196111 701.19545391 1024.65557343 C697.74302285 1024.66329601 694.29080385 1024.6620256 690.8383815 1024.65701788 C687.08714701 1024.65375688 683.3359353 1024.66202909 679.58470803 1024.66883624 C673.00594406 1024.67915536 666.42720953 1024.68197672 659.84843826 1024.67992401 C650.06558012 1024.67687899 640.28275466 1024.68518691 630.49990286 1024.69567326 C612.01265542 1024.71503574 593.52541905 1024.72064232 575.03816267 1024.72178738 C560.76393791 1024.72270572 546.4897175 1024.72681853 532.21549416 1024.73318863 C528.10979552 1024.73498366 524.00409687 1024.73676329 519.89839822 1024.73853838 C518.87777078 1024.73898048 517.85714335 1024.73942258 516.8055878 1024.73987807 C488.08925768 1024.75218998 459.37292906 1024.76007884 430.65659618 1024.75919151 C429.5734743 1024.75916036 428.49035242 1024.7591292 427.37440866 1024.7590971 C421.88443242 1024.75893088 416.39445618 1024.75873279 410.90447994 1024.75852768 C409.26892411 1024.75846785 409.26892411 1024.75846785 407.60032674 1024.7584068 C405.39533103 1024.75832593 403.19033533 1024.75824233 400.98533962 1024.75815602 C366.67307589 1024.75693029 332.36085167 1024.77194628 298.04859924 1024.79930115 C259.51808873 1024.83000614 220.98760419 1024.84723461 182.45708066 1024.8453747 C178.35043895 1024.84522544 174.24379724 1024.84512803 170.13715553 1024.84506607 C169.12596127 1024.84504276 168.114767 1024.84501945 167.07293048 1024.84499544 C150.78316413 1024.84493383 134.49343202 1024.85771865 118.20367586 1024.8749306 C101.83902148 1024.89186435 85.47441733 1024.89387865 69.10975906 1024.88071196 C59.38216311 1024.87330776 49.65471948 1024.8770245 39.92713959 1024.89659664 C33.4329624 1024.90856141 26.938896 1024.90604475 20.44472397 1024.89165564 C16.74211219 1024.88386289 13.03979599 1024.88242575 9.3372046 1024.89857034 C5.35063481 1024.91580131 1.36451237 1024.90217392 -2.62206745 1024.88545799 C-3.77400297 1024.89539435 -4.92593848 1024.90533071 -6.11278114 1024.91556817 C-13.91828136 1024.84599237 -18.92066356 1023.50361354 -25.23143005 1018.7118988 C-25.76123474 1018.17178162 -26.29103943 1017.63166443 -26.8368988 1017.07518005 C-27.37959412 1016.54279724 -27.92228943 1016.01041443 -28.48143005 1015.4618988 C-32.32573639 1010.2939832 -33.39939032 1005.54846643 -33.40159696 999.19241101 C-33.40592815 998.49836405 -33.41025933 997.8043171 -33.41472176 997.08923843 C-33.42557085 994.76553518 -33.41509779 992.44242777 -33.40471554 990.11872959 C-33.408149 988.42802618 -33.41289577 986.73732502 -33.4188365 985.04662856 C-33.4313808 980.38485558 -33.42518061 975.72326488 -33.41600283 971.06149094 C-33.40931018 965.99581533 -33.4199505 960.93017172 -33.42839867 955.86450285 C-33.44079221 946.98098645 -33.44196644 938.09752284 -33.43584824 929.2140007 C-33.42677458 916.00405537 -33.43477517 902.79415904 -33.44613948 889.58421747 C-33.46640443 865.30809999 -33.46786294 841.03200415 -33.46248886 816.75588246 C-33.46173315 813.31573222 -33.46100553 809.87558197 -33.46030688 806.43543172 C-33.46016779 805.75214681 -33.4600287 805.06886189 -33.45988539 804.36487138 C-33.45693381 789.2260089 -33.45994519 774.08714937 -33.46420317 758.94828743 C-33.46478533 756.87671256 -33.46535417 754.8051377 -33.4659188 752.73356283 C-33.46743374 747.18046801 -33.46896064 741.62737319 -33.47051181 736.07427838 C-33.48126953 697.30606719 -33.4859693 658.53785873 -33.47804165 619.76964664 C-33.47789334 619.03877357 -33.47774504 618.30790049 -33.47759224 617.55487975 C-33.47593321 609.40473237 -33.47418363 601.25458501 -33.47239923 593.10443766 C-33.4722382 592.36858883 -33.47207718 591.63274001 -33.47191127 590.87459274 C-33.47060344 584.90231717 -33.47060344 584.90231717 -33.46995008 581.94708912 C-33.45955738 534.87331689 -33.46732697 487.79958205 -33.49095154 440.72581482 C-33.49689483 428.86376229 -33.50278635 417.00170973 -33.50836086 405.13965702 C-33.50870463 404.40928609 -33.5090484 403.67891516 -33.50940259 402.92641177 C-33.5199281 380.42067229 -33.52552389 357.91493594 -33.52591801 335.40919399 C-33.52593079 334.70274966 -33.52594357 333.99630533 -33.52595674 333.26845359 C-33.52618502 317.76137779 -33.52517906 302.25430226 -33.52304769 286.7472266 C-33.52229291 281.19874963 -33.5216147 275.65027265 -33.52096754 270.10179566 C-33.52080485 268.72145324 -33.52063718 267.34111083 -33.52046452 265.96076841 C-33.51774204 243.95587244 -33.52630309 221.95099915 -33.54031863 199.94610805 C-33.55471785 177.17184266 -33.55428431 154.39761127 -33.53694391 131.62334497 C-33.52735484 118.48753745 -33.52886881 105.35184056 -33.54617859 92.21604035 C-33.55662697 83.45011239 -33.55262591 74.68426914 -33.53669856 65.91834959 C-33.528023 60.9182773 -33.52574831 55.9184226 -33.54096787 50.91836108 C-33.55467624 46.37204341 -33.55006722 41.82613101 -33.53068269 37.27983737 C-33.52693877 35.64312463 -33.52993188 34.00637949 -33.54039577 32.36969593 C-33.59709447 22.84710129 -33.27763505 15.98926159 -27.34861755 8.1806488 C-26.80850037 7.65084412 -26.26838318 7.12103943 -25.7118988 6.57518005 C-25.17951599 6.03248474 -24.64713318 5.48978943 -24.09861755 4.9306488 C-16.62899433 -0.62585058 -8.97499759 -0.03928405 0 0 Z M18.9756012 52.38768005 C18.9756012 355.98768005 18.9756012 659.58768005 18.9756012 972.38768005 C238.0956012 972.38768005 457.2156012 972.38768005 682.9756012 972.38768005 C682.9756012 786.92768005 682.9756012 601.46768005 682.9756012 410.38768005 C572.14469434 410.21713575 572.14469434 410.21713575 461.31373596 410.08982849 C439.89930725 410.04441833 439.89930725 410.04441833 429.8807373 410.01811218 C422.86944117 410.001077 415.85823836 409.99492138 408.84692383 409.99613953 C400.7611745 409.99750692 392.67558651 409.98509079 384.58988851 409.95564117 C380.45355543 409.94100951 376.31747351 409.93257185 372.18111908 409.94185591 C368.43854051 409.95013772 364.69647614 409.93999737 360.95397377 409.91533852 C358.96431698 409.9069757 356.97460741 409.91819624 354.98496914 409.9301796 C346.34727175 409.84747821 339.92056463 408.63131666 333.1631012 403.07518005 C328.54663962 397.40352726 325.8561226 392.14315419 325.836936 384.7398653 C325.83146155 383.55650445 325.82598711 382.3731436 325.82034677 381.15392333 C325.81887961 379.19432033 325.81887961 379.19432033 325.81738281 377.19512939 C325.81281837 375.79835626 325.80781852 374.40158449 325.80241925 373.00481433 C325.78881532 369.15786341 325.78141327 365.31092136 325.77499259 361.46395266 C325.76699854 357.31876181 325.75329734 353.17358944 325.74028015 349.02841187 C325.71850327 341.84370311 325.70036321 334.65899249 325.68467522 327.47426796 C325.66198762 317.08629098 325.63384326 306.69833446 325.60435594 296.31037482 C325.5566664 279.45765291 325.51340591 262.60492264 325.47291565 245.75218201 C325.43356765 229.37880299 325.39213173 213.00543144 325.34791565 196.63206482 C325.34516614 195.61295279 325.34241664 194.59384076 325.33958381 193.54384655 C325.31806537 185.5740276 325.2964256 177.60420899 325.27474749 169.63439047 C325.16847394 130.55216871 325.07278471 91.46992752 324.9756012 52.38768005 C223.9956012 52.38768005 123.0156012 52.38768005 18.9756012 52.38768005 Z M376.9756012 88.38768005 C376.9756012 177.48768005 376.9756012 266.58768005 376.9756012 358.38768005 C465.7456012 358.38768005 554.5156012 358.38768005 645.9756012 358.38768005 C642.25084807 354.04213474 638.68992281 349.97838912 634.66958618 345.96813965 C634.17120521 345.46960981 633.67282423 344.97107998 633.1593408 344.45744318 C631.51069709 342.80948663 629.85852158 341.16511962 628.20631409 339.52073669 C627.01460831 338.33095272 625.82313195 337.14093892 624.63186646 335.95071411 C622.07643546 333.39843195 619.51946213 330.84770888 616.9612751 328.29818916 C612.91091043 324.26140583 608.8644153 320.22075842 604.81848145 316.17953491 C595.49854428 306.87161568 586.17359815 297.56871987 576.84859467 288.26587677 C568.30106672 279.73856089 559.75461612 271.21017255 551.21221918 262.6777162 C547.19553579 258.66599593 543.17643129 254.65672233 539.15541661 250.64934361 C536.64821543 248.14963677 534.14311922 245.64782839 531.63857079 243.14546394 C530.48296764 241.99172226 529.32650571 240.83883996 528.16909027 239.68691635 C518.34137059 229.90433685 518.34137059 229.90433685 514.54367065 225.45773315 C509.3679011 219.41175876 503.61684539 213.88971971 497.98780823 208.27049255 C496.6778634 206.9591908 495.36813099 205.64767682 494.05859375 204.33596802 C490.52212683 200.79496459 486.98253136 197.25710439 483.44220591 193.71995926 C479.7349483 190.01524109 476.03013974 186.3080751 472.32493591 182.6013031 C466.11132936 176.38588108 459.89562534 170.17256249 453.6787262 163.96043396 C446.48250865 156.76967461 439.28992327 149.57529724 432.09918129 142.37906265 C425.92341793 136.1987704 419.74571945 130.02041752 413.56638038 123.84370041 C409.87602611 120.154908 406.18635771 116.4654364 402.49843216 112.7742157 C399.03855415 109.31146169 395.57626337 105.85113884 392.1120472 102.39272499 C390.83766657 101.11967271 389.5641474 99.84575744 388.2915287 98.57094383 C386.56262465 96.8393316 384.83070975 95.1107902 383.09794617 93.38304138 C382.58813772 92.87100222 382.07832928 92.35896305 381.55307209 91.83140755 C379.60125542 89.43404065 379.60125542 89.43404065 376.9756012 88.38768005 Z " fill="#000000" transform="translate(161.02439880371094,-0.3876800537109375)"/>
            <path stroke="#575757" stroke-width="50" d="M0 0 C1.33455105 -0.00734878 2.66909576 -0.01593736 4.00363159 -0.02566528 C7.61333425 -0.04780765 11.22280812 -0.05081557 14.83256936 -0.04891777 C17.85415757 -0.04879771 20.87569794 -0.05737666 23.89727277 -0.06569529 C31.03132005 -0.08490402 38.16525035 -0.0878228 45.29931641 -0.08105469 C52.6390743 -0.07441903 59.978329 -0.09726449 67.31798488 -0.13436842 C73.63673064 -0.16514277 79.9553152 -0.17641701 86.27413434 -0.1725316 C90.04046278 -0.17047167 93.8063997 -0.17582492 97.57265663 -0.20042419 C101.11798079 -0.22281698 104.6624918 -0.22071145 108.20782089 -0.20049667 C110.11430988 -0.19550416 112.02081489 -0.21501567 113.92720032 -0.23550415 C122.7276259 -0.15020078 129.59799671 1.61951752 136.2253418 7.63085938 C136.7409668 8.345 137.2565918 9.05914063 137.7878418 9.79492188 C138.5922168 10.85839844 138.5922168 10.85839844 139.4128418 11.94335938 C143.38037989 19.08943651 143.08438391 26.28319078 143.07836914 34.26489258 C143.08508636 35.54707672 143.09180359 36.82926086 143.09872437 38.15029907 C143.11631935 41.65252972 143.12107699 45.15466249 143.12235594 48.65693307 C143.12378183 50.84959369 143.12805969 53.04222976 143.13335037 55.23488426 C143.15182937 62.89740949 143.16002369 70.55986534 143.15844727 78.22241211 C143.15724654 85.34396868 143.17834057 92.46522185 143.20993459 99.58670169 C143.23616054 105.71859758 143.24681192 111.85039475 143.24553645 117.98234624 C143.24502865 121.63684635 143.25060992 125.2910766 143.27189255 128.9455204 C143.29501046 133.02614419 143.28571563 137.10609595 143.27368164 141.18676758 C143.28492065 142.38346573 143.29615967 143.58016388 143.30773926 144.81312561 C143.24050236 153.81156926 141.68739284 161.32650816 135.7253418 168.29492188 C130.58136377 172.96424099 123.70311266 175.4797301 116.7878418 175.91992188 C109.84489212 175.4779682 102.97703288 172.96305957 97.8503418 168.23242188 C90.46580035 159.54647697 90.18472131 150.64135046 90.1784668 139.66601562 C90.16346222 138.15428415 90.14673034 136.64256892 90.12835693 135.13087463 C90.08492598 131.18048287 90.06473876 127.23031214 90.04962158 123.27972412 C90.02996224 119.23713237 89.98800261 115.1947763 89.94799805 111.15234375 C89.87295926 103.24159857 89.82250924 95.33094658 89.7878418 87.41992188 C88.5055317 89.16610592 87.22554492 90.91399624 85.9465332 92.66259766 C85.2334903 93.63576935 84.52044739 94.60894104 83.78579712 95.61160278 C81.33436153 99.05733217 79.18620834 102.58637868 77.1628418 106.29492188 C76.78659668 106.97852783 76.41035156 107.66213379 76.02270508 108.36645508 C54.72807016 147.48862667 48.47993295 193.21266042 60.6003418 236.29492188 C68.82880791 264.00452234 82.56786476 288.70032331 102.7878418 309.41992188 C103.6128418 310.31839844 104.4378418 311.216875 105.2878418 312.14257812 C132.8592396 341.35312915 175.08824917 358.28182058 214.7878418 360.41992188 C221.12040549 360.44402172 227.45231291 360.30270687 233.78198242 360.1171875 C243.01162924 359.99088215 249.75170929 361.28632831 257.6003418 366.16992188 C264.48431841 373.25058353 266.21796959 380.04699618 266.12768555 389.76757812 C265.47448745 396.78758064 262.56779726 402.09810634 257.4128418 406.85742188 C241.63630105 418.89383443 212.87619441 414.15388428 194.43408203 411.90039062 C175.65215689 409.32919954 157.41211353 404.36112778 139.7878418 397.41992188 C139.04550293 397.12923828 138.30316406 396.83855469 137.53833008 396.5390625 C119.70588379 389.41708924 102.68830536 379.53504043 87.7878418 367.41992188 C86.91901367 366.74058594 86.05018555 366.06125 85.1550293 365.36132812 C74.30773154 356.74357699 63.44837277 347.27995278 54.7878418 336.41992188 C53.96155273 335.40800781 53.13526367 334.39609375 52.28393555 333.35351562 C19.75534574 293.11670194 1.21627156 243.73589128 1.4753418 191.85742188 C1.47749695 191.07378265 1.4796521 190.29014343 1.48187256 189.48275757 C1.53982457 176.27857667 2.24713934 163.4088029 4.7878418 150.41992188 C4.98120117 149.43056641 5.17456055 148.44121094 5.3737793 147.421875 C9.64286149 126.43222088 16.54937933 106.14608755 26.77416992 87.29101562 C27.82360977 85.35389929 28.84435227 83.40308342 29.8659668 81.45117188 C33.75451141 74.17010613 38.06741366 67.47809118 43.0847168 60.91992188 C43.63562988 60.19289063 44.18654297 59.46585938 44.75415039 58.71679688 C46.09504448 56.94832919 47.43961851 55.18280422 48.7878418 53.41992188 C47.69362411 53.41445343 47.69362411 53.41445343 46.57730103 53.40887451 C39.66358587 53.37082538 32.75025262 53.31378277 25.83687782 53.23601913 C22.28356856 53.19670391 18.73050117 53.16443831 15.17700195 53.14892578 C11.08074209 53.13072192 6.98538312 53.08070206 2.8894043 53.02929688 C1.62859039 53.02806824 0.36777649 53.0268396 -0.9312439 53.02557373 C-10.40092986 52.87002954 -19.2550465 51.37703358 -26.2121582 44.41992188 C-32.12637584 36.64695013 -33.29142197 28.98714551 -32.2121582 19.41992188 C-29.67901104 11.15326751 -24.83969718 5.98356602 -17.41047668 1.86779785 C-11.84770305 -0.46260297 -5.93235888 -0.01401851 0 0 Z " fill="#000000" transform="translate(288.212158203125,503.580078125)"/>
            <path stroke="#575757" stroke-width="50" d="M0 0 C0.90540527 0.75313477 0.90540527 0.75313477 1.82910156 1.52148438 C11.68655419 9.74376564 20.68709712 18.11958991 28.7265625 28.17578125 C30.17004604 29.96897472 31.64131143 31.74042319 33.1484375 33.48046875 C48.37090329 51.20337567 60.11184995 73.07730697 68 95 C68.2470166 95.66757324 68.4940332 96.33514648 68.74853516 97.02294922 C72.07682649 106.08037028 74.66970055 115.20159477 76.75 124.625 C77.04789429 125.96401367 77.04789429 125.96401367 77.35180664 127.33007812 C80.50231887 142.30142016 81.37795637 156.94001644 81.3125 172.1875 C81.31034485 173.09274414 81.3081897 173.99798828 81.30596924 174.93066406 C81.25537678 188.17711464 80.8437759 201.01798561 78 214 C77.69400879 215.46614746 77.69400879 215.46614746 77.38183594 216.96191406 C70.50372907 249.47022992 57.39389886 278.87592072 37.82714844 305.74462891 C36.7508316 307.22305771 36.7508316 307.22305771 35.652771 308.73135376 C35.10735657 309.48000702 34.56194214 310.22866028 34 311 C35.07875648 310.99000725 35.07875648 310.99000725 36.17930603 310.97981262 C42.99002592 310.91945159 49.8007053 310.87389936 56.61162472 310.84456348 C60.11237531 310.82897401 63.61290302 310.80786059 67.11352539 310.77368164 C71.14731871 310.73454795 75.18088156 310.72023538 79.21484375 310.70703125 C80.45894516 310.69154739 81.70304657 310.67606354 82.98484802 310.66011047 C93.1929423 310.65815114 100.71675903 311.98866586 108.2734375 319.09375 C114.09952442 325.52617176 115.42482792 332.09078069 115.33984375 340.5703125 C114.5809464 348.22906964 110.896573 353.91292622 105.0390625 358.74609375 C97.60869747 363.31534121 91.39893664 363.44027039 82.7878418 363.41992188 C81.45329075 363.42727066 80.11874604 363.43585924 78.78421021 363.44558716 C75.17450755 363.46772952 71.56503367 363.47073745 67.95527244 363.46883965 C64.93368423 363.46871958 61.91214386 363.47729853 58.89056903 363.48561716 C51.75652174 363.50482589 44.62259145 363.50774467 37.48852539 363.50097656 C30.1487675 363.49434091 22.8095128 363.51718637 15.46985692 363.55429029 C9.15111115 363.58506465 2.83252659 363.59633889 -3.48629254 363.59245348 C-7.25262099 363.59039355 -11.0185579 363.59574679 -14.78481483 363.62034607 C-18.33013899 363.64273886 -21.87465 363.64063332 -25.4199791 363.62041855 C-27.32646808 363.61542604 -29.23297309 363.63493755 -31.13935852 363.65542603 C-39.58644321 363.57354763 -46.28030662 362.01297941 -52.83139515 356.44283295 C-60.22586495 348.64906899 -60.44257937 339.16016285 -60.40405273 328.92797852 C-60.41091599 327.64550232 -60.41777924 326.36302612 -60.42485046 325.04168701 C-60.44268597 321.54778474 -60.44163184 318.05413492 -60.43590808 314.56020093 C-60.43280231 311.63295713 -60.438924 308.70576086 -60.44494683 305.77852386 C-60.4589588 298.86785208 -60.45745853 291.95730401 -60.44604492 285.04663086 C-60.43456601 277.93978583 -60.44864289 270.83331829 -60.4754414 263.72652298 C-60.49765924 257.60306679 -60.50422216 251.47972857 -60.49836498 245.35623497 C-60.4950088 241.70848824 -60.4973206 238.06098341 -60.51461601 234.41327095 C-60.53307818 230.34241266 -60.51883586 226.27228021 -60.50170898 222.20141602 C-60.51137695 221.00785995 -60.52104492 219.81430389 -60.53100586 218.58457947 C-60.45770688 210.23795368 -59.15878518 203.12362812 -53.9921875 196.37890625 C-46.97937811 190.36238159 -40.70744118 187.57267574 -31.375 188.0625 C-23.05042525 189.1880763 -18.06129139 192.37013136 -12.54296875 198.609375 C-7.24138061 206.82348118 -7.52798883 215.22322885 -7.48828125 224.65625 C-7.47141309 226.16940753 -7.45326 227.68255122 -7.43388367 229.19567871 C-7.38660907 233.1542529 -7.35665468 237.11277099 -7.33044434 241.0715332 C-7.30052425 245.12071811 -7.2540336 249.16971016 -7.20898438 253.21875 C-7.12320815 261.14573806 -7.05574958 269.07274414 -7 277 C-5.0944793 274.17486978 -3.1951868 271.34560313 -1.296875 268.515625 C-0.76433105 267.72623535 -0.23178711 266.9368457 0.31689453 266.12353516 C13.34723883 246.66781434 22.09677048 225.13111002 26 202 C26.2638147 200.45916748 26.2638147 200.45916748 26.53295898 198.88720703 C27.90914521 190.18217138 28.35120703 181.68140267 28.3125 172.875 C28.31034485 172.20124329 28.3081897 171.52748657 28.30596924 170.83331299 C28.0823806 127.01898682 11.00339173 86.72772459 -19 55 C-19.85722656 54.06671875 -20.71445312 53.1334375 -21.59765625 52.171875 C-49.48847286 22.49808382 -91.82918487 5.36048886 -132.09765625 3.06640625 C-135.36304805 3.01083902 -138.60654851 3.03163109 -141.87109375 3.08984375 C-142.93021973 3.1043457 -143.9893457 3.11884766 -145.08056641 3.13378906 C-147.18354321 3.16873807 -149.2863171 3.2230577 -151.38818359 3.29980469 C-160.59847791 3.47212925 -167.65375614 0.96588185 -174.49609375 -5.2890625 C-179.34351053 -10.80378601 -181.32682273 -17.53077397 -181.21875 -24.78515625 C-180.53545366 -31.70353173 -177.67874566 -38.76988186 -172.3984375 -43.40625 C-128.90190617 -76.36397418 -34.19254438 -28.67258427 0 0 Z " fill="#000000" transform="translate(653,522)"/>
            </svg>)
    }

    render() {
        return (
            <React.Fragment>
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    severity={ERROR}
                    message={this.state.errorMessage}
                    handleClose={this.closeTag}
                />
                <TopToolbar
                    pageName={FULL_TRUCKLOAD}
                    menuItems={[
                        {title: BACK, icon: <ArrowBackIcon/>, onClick: () => {this.state.activeStep === 0 ? this.props.setCurrentPage(FTL_PAGES.TABLE) : this.handleBack()}},
                        {title: this.state.status === FTL_STATUSES.DRAFT? SAVE_DRAFT : SAVE, icon: <SaveIcon/>, onClick: () => {this.handleSave()}, disabled: !this.state.allowChangeOfStatus ||!this.state.fromAddress.selectedLocation || !this.state.toAddress.selectedLocation || !this.state.carrierName ||
                        (this.state?.dutiesTaxesPayableBy === DUTIES_TAXES_PAYABLE_BY_OPTIONS[0] && !this.state.dutiesTaxesPayableByExporter) ||
                        (this.state?.dutiesTaxesPayableBy === DUTIES_TAXES_PAYABLE_BY_OPTIONS[2] && !this.state.dutiesTaxesPayableByOther)||
                                ((this.state.status === FTL_STATUSES.SHIPPED || this.state.status === FTL_STATUSES.RECEIVED || this.state.status === FTL_STATUSES.COMPLETED) && !this.userIsAnAdmin())
                        },
                        {title: NEXT, icon: <ArrowForwardIcon/>, onClick: () => this.handleNext(), disabled: this.state.activeStep === FTL_STEPPER_HEADINGS.length - 1 || (this.props.creating == true && this.state.shipmentFor === "")},
                        {title: '|', isNotIcon: true},
                        {title: MARK_DRAFT_FTL, icon: <DesignServicesIcon/>, onClick: () => {this.changeStatus(FTL_STATUSES.DRAFT, MARK_DRAFT_FTL)}, disabled: !this.state.allowChangeOfStatus || this.state.status === FTL_STATUSES.DRAFT || this.state.status === FTL_STATUSES.SHIPPED || this.state.status === FTL_STATUSES.RECEIVED || this.state.status === FTL_STATUSES.COMPLETED || (this.state.status === FTL_STATUSES.APPROVED && !this.props.user.routes.includes('ftl-approval'))},
                        {title: UNAPPROVE_FTL, icon: <CancelIcon/>, onClick: () => {this.changeStatus(FTL_STATUSES.REQUEST_APPROVAL, UNAPPROVE_FTL)}, disabled: !this.state.allowChangeOfStatus || this.state.status !== FTL_STATUSES.APPROVED || !this.props.user.routes.includes('ftl-approval')},
                        {title: APPROVE_FTL, icon: <CheckIcon/>, onClick: () => {this.changeStatus(FTL_STATUSES.APPROVED, APPROVE_FTL)}, disabled: !this.state.allowChangeOfStatus || this.state.status !== FTL_STATUSES.REQUEST_APPROVAL || !this.props.user.routes.includes('ftl-approval')},
                        {title: MARK_FTL_UNSHIPPED, icon: <ScheduleIcon/>, onClick: () => {this.changeStatus(FTL_STATUSES.APPROVED, MARK_FTL_UNSHIPPED)}, disabled: !this.state.allowChangeOfStatus || this.state.status !== FTL_STATUSES.SHIPPED || !this.props.user.routes.includes('ftl-approval')},
                        {title: MARK_FTL_SHIPPED, icon: <AssignmentTurnedIn/>, onClick: () => {this.changeStatus(FTL_STATUSES.SHIPPED, MARK_FTL_SHIPPED)}, disabled: !this.state.allowChangeOfStatus || this.state.status !== FTL_STATUSES.APPROVED || !this.props.user.routes.includes('ftl-approval')},
                        {title: MARK_FTL_INCOMPLETE, icon: <Unpublished/>, onClick: () => {this.changeStatus(FTL_STATUSES.RECEIVED, MARK_FTL_INCOMPLETE)}, disabled: !this.state.allowChangeOfStatus || this.state.status !== FTL_STATUSES.COMPLETED || !this.props.user.routes.includes('ftl-approval')},
                        {title: MARK_FTL_COMPLETE, icon: <CheckCircleIcon/>, onClick: () => {this.changeStatus(FTL_STATUSES.COMPLETED, MARK_FTL_COMPLETE)}, disabled: !this.state.allowChangeOfStatus || this.state.status !== FTL_STATUSES.RECEIVED || !this.props.user.routes.includes('ftl-approval')},
                        {title: '|', isNotIcon: true},
                        {title: UPLOAD_BOL_AND_CI, icon: <PublishIcon/>, onClick: () => {this.props.setCurrentPage(FTL_PAGES.UPLOAD)}, disabled: this.state.status === FTL_STATUSES.COMPLETED || this.state.status === FTL_STATUSES.DRAFT},
                        {title: VIEW_BOL, icon: <DescriptionIcon/>, onClick: () => this.handlePreview(false), disabled: this.state.status !== FTL_STATUSES.APPROVED && this.state.status !== FTL_STATUSES.SHIPPED && this.state.status !== FTL_STATUSES.RECEIVED && this.state.status !== FTL_STATUSES.COMPLETED || !this.props.user.routes.includes('ftl-approval')},
                        {title: VIEW_DOCUMENTS, icon: <FileCopyIcon/>, onClick: () => this.handlePreview(true), disabled: this.state.status !== FTL_STATUSES.APPROVED && this.state.status !== FTL_STATUSES.SHIPPED && this.state.status !== FTL_STATUSES.RECEIVED && this.state.status !== FTL_STATUSES.COMPLETED  || !this.props.user.routes.includes('ftl-approval')},
                        {title: FTL_EXPORT, icon: <DownloadIcon/>, onClick: () => {this.handleDownload()}, disabled: this.allowDownload()},
                        this.userIsAnAdmin() && this.state.status !== FTL_STATUSES.DRAFT && this.state.status !== FTL_STATUSES.REQUEST_APPROVAL && this.state.status !== FTL_STATUSES.APPROVED && {
                            title: REGENERATE_DOCUMENT,
                            icon: this.regenerateIcon(),
                            onClick: () => { this.handleRegenerateDocument() }}
                        ]}
                />

                <Stepper nonLinear={!this.props.creating} activeStep={this.state.activeStep} alternativeLabel>
                    {FTL_STEPPER_HEADINGS.map((label, index) => (
                        <Step key={label}>
                            <StepButton
                                onClick={() => {
                                    this.setStep(index);
                                }}
                                optional={
                                    <Typography variant='caption'>
                                        {FTL_STEPPER_HEADING_DESCRIPTIONS[index]}
                                    </Typography>
                                }
                            >
                                {label}
                            </StepButton>
                        </Step>
                    ))}
                </Stepper>
                <DndProvider backend={HTML5Backend}>
                    {this.getStepContent(this.state.activeStep)}
                </DndProvider>
                <div className="ftl-stepper-buttons">
                    {this.state.activeStep !== 0 &&
                        <Button
                            style={{marginRight: "10px", width: "5%"}}
                            variant='contained'
                            onClick={this.handleCancel}
                        >
                            {CANCEL}
                        </Button>
                    }

                    <Button
                        style={{marginRight: "10px", width: "5%"}}
                        variant='contained'
                        onClick={this.handleBack}
                    >
                        {this.state.activeStep === 0 ? CANCEL : BACK}
                    </Button>

                    <Button
                        variant='contained'
                        color={this.state.status === FTL_STATUSES.DRAFT? "" : 'primary'}
                        onClick={this.handleSave}
                        style={{width: this.state.status === FTL_STATUSES.DRAFT ? "9%" : "5%"}}
                        disabled={!this.state.allowChangeOfStatus || !this.state.fromAddress.selectedLocation || !this.state.toAddress.selectedLocation || !this.state.carrierName ||
                        (this.state?.dutiesTaxesPayableBy === DUTIES_TAXES_PAYABLE_BY_OPTIONS[0] && !this.state.dutiesTaxesPayableByExporter) ||
                        (this.state?.dutiesTaxesPayableBy === DUTIES_TAXES_PAYABLE_BY_OPTIONS[2] && !this.state.dutiesTaxesPayableByOther) ||
                            ((this.state.status === FTL_STATUSES.SHIPPED || this.state.status === FTL_STATUSES.RECEIVED || this.state.status === FTL_STATUSES.COMPLETED) && !this.userIsAnAdmin())
                    }
                    >
                        {this.state.status === FTL_STATUSES.DRAFT? SAVE_DRAFT : SAVE}
                    </Button>

                    {this.state.status === FTL_STATUSES.DRAFT && this.state.activeStep === FTL_STEPPER_HEADINGS.length - 1 ?
                        <div>
                            <br/>
                        </div>
                        :
                        null
                    }

                    {this.state.activeStep === FTL_STEPPER_HEADINGS.length - 1  && this.state.status !== FTL_STATUSES.DRAFT ?
                     <></> :
                        <Button
                            style={{marginLeft: "10px", width: this.state.activeStep === FTL_STEPPER_HEADINGS.length - 1 ? "12%" : "5%"}}
                            disabled={this.state.status === FTL_STATUSES.COMPLETED && this.state.activeStep === FTL_STEPPER_HEADINGS.length - 1 || (this.props.creating == true && this.state.shipmentFor === "")}
                            variant='contained'
                            color='primary'
                            onClick={() => this.handleNext()}
                        >
                            {this.state.activeStep === FTL_STEPPER_HEADINGS.length - 1 ? REQUEST_FOR_APPROVAL : NEXT}
                        </Button>
                    }
                </div>
                <div className="ftl-stepper-buttons">
                    {this.state.activeStep === 0 && this.state.status === FTL_STATUSES.DRAFT ?
                        <Button
                            style={{
                                width: "20.1%"
                            }}
                            disabled={!this.isAutoPlan()}
                            variant='contained'
                            color='primary'
                            onClick={() => this.handleNextAndCalculate()}
                        >
                            {GENERATE}
                        </Button>
                        :
                        <></>
                    }
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    products: productsSelector(state),
    packages: packagesSelector(state),
    inventorySummaryForFTL: inventorySummaryForFTLSelector(state),
    openPOsForFTL: openPOsForFTLSelector(state),
    stateAndProvinceMapping: stateAndProvinceMappingSelector(state),
    availableLocations: availableLocationsSelector(state),
    fullTruckloadCarriers: fullTruckloadCarriersSelector(state),
    fullTruckloadBrokers: fullTruckloadBrokersSelector(state),
    fullTruckloadSettings: fullTruckloadSettingsSelector(state),
    unavailableItems: fullTruckloadUnavailableItemsSelector(state),
    productsSupplier: productsSupplierSelector(state),
    operationResponse: fullTruckloadOperationResponseSelector(state)
});

const actionCreators = {
    fetchFullTruckloadSettings,
    listProducts,
    listPackages,
    getInventorySummaryForFTL,
    saveFullTruckload,
    updateFullTruckload,
    getStateAndProvinceMapping,
    listAvailableLocations,
    listFullTruckloadCarriers,
    fetchFullTruckloadCarriers,
    listFullTruckloadBrokers,
    fetchFullTruckloadBrokers,
    getOpenPOsForFTL,
    fetchProductSuppliers,
    regenerateFTLDocument,
}

export default withShipment({
    mapStateToProps,
    actionCreators,
}, FullTruckloadForm);